/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { marketingApi } from "../api/marketingApi";
import api from "../../../shared/api/apiClient";
import "./MarketingPage.css";
import { useTranslation } from "react-i18next";

const CAMPAIGN_STATUSES = ["draft", "scheduled", "active", "sending", "completed", "cancelled", "expired", "pending_delete"];
const COUPON_STATUSES = ["active", "used", "expired", "cancelled"];
const GLOBAL_BIRTHDAY_ACTIVE_STATUSES = ["draft", "scheduled", "active", "sending"];
const BIRTHDAY_FIELD_KEYS = ["birthday", "birth_date", "date_of_birth", "dob"];

const CHANNEL_LABELS = {
  email: "marketing_channel_email_name",
  telegram: "marketing_channel_telegram_name",
  both: "marketing_channel_both",
};

const TRIGGER_LABELS = {
  immediate: "marketing_launch_immediately",
  scheduled: "marketing_by_date",
  birthday: "marketing_birthday",
};

const TYPE_LABELS = {
  global: "marketing_global_short",
  personal: "marketing_personal_short",
};

const CAMPAIGN_WIZARD_STEPS = [
  {
    title: "marketing_wizard_step_main",
    hint: "marketing_wizard_step_main_hint",
  },
  {
    title: "marketing_wizard_step_message",
    hint: "marketing_wizard_step_message_hint",
  },
  {
    title: "marketing_wizard_step_recipients",
    hint: "marketing_wizard_step_recipients_hint",
  },
  {
    title: "marketing_wizard_step_conditions",
    hint: "marketing_wizard_step_conditions_hint",
  },
  {
    title: "marketing_wizard_step_review",
    hint: "marketing_wizard_step_review_hint",
  },
];

const CAMPAIGN_WIZARD_LAST_STEP = CAMPAIGN_WIZARD_STEPS.length - 1;

const QUICK_TEMPLATES = [
  {
    key: "sale",
    title: "marketing_new_campaign",
    description: "marketing_template_sale_description",
    campaign_type: "global",
    trigger_type: "scheduled",
    delivery_channel: "both",
    telegram_text: "marketing_template_sale_telegram",
    email_subject: "marketing_template_sale_email_subject",
    email_html: "marketing_template_sale_email_html",
  },
  {
    key: "birthday",
    title: "marketing_birthday",
    description: "marketing_template_global_birthday_description",
    campaign_type: "global",
    trigger_type: "birthday",
    delivery_channel: "both",
    telegram_text: "marketing_template_birthday_telegram",
    email_subject: "marketing_template_birthday_email_subject",
    email_html: "marketing_template_birthday_email_html",
  },
  {
    key: "telegram",
    title: "marketing_template_telegram_title",
    description: "marketing_template_telegram_description",
    campaign_type: "global",
    trigger_type: "immediate",
    delivery_channel: "telegram",
    telegram_text: "marketing_template_telegram_message",
    email_subject: "",
    email_html: "",
  },
  {
    key: "after_order",
    title: "marketing_template_after_order_title",
    description: "marketing_template_after_order_description",
    campaign_type: "personal",
    trigger_type: "immediate",
    delivery_channel: "both",
    telegram_text: "marketing_template_after_order_telegram",
    email_subject: "marketing_template_after_order_email_subject",
    email_html: "marketing_template_after_order_email_html",
  },
];

const PROFESSIONAL_EMAIL_TEMPLATE = `<!doctype html>
<html lang="ru">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title>{{campaign_title}}</title>
</head>
<body style="margin:0;padding:0;background:#f5f7fb;font-family:Arial,Helvetica,sans-serif;color:#111827;">
<div data-vcrm-preheader="true" style="display:none;max-height:0;overflow:hidden;opacity:0;">Персональное предложение от {{company_name}}.</div>
<table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="background:#f5f7fb;padding:24px 12px;">
<tr>
<td align="center">
<table width="560" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;max-width:560px;background:#ffffff;border-radius:16px;overflow:hidden;border:1px solid #e5e7eb;">
<tr>
<td style="padding:24px 28px 18px;background:#0f2f75;">
{{company_logo_img}}
<div style="font-size:20px;line-height:26px;font-weight:800;color:#ffffff;margin-top:8px;">{{company_name}}</div>
<div style="font-size:13px;line-height:20px;color:#bfdbfe;margin-top:6px;">Персональное предложение</div>
</td>
</tr>

<tr>
<td style="padding:30px 28px 10px;">
<h1 style="margin:0 0 14px;font-size:26px;line-height:33px;color:#111827;font-weight:800;">Здравствуйте, {{contact_name}}!</h1>
<p style="margin:0 0 22px;font-size:15px;line-height:24px;color:#4b5563;">Для вас доступна акция от <strong>{{company_name}}</strong>. Используйте промокод ниже, чтобы получить специальное предложение.</p>

<table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="border:1px solid #dbe3ef;border-radius:12px;background:#f8fafc;">
<tr>
<td style="padding:20px;">
<div style="font-size:11px;line-height:16px;text-transform:uppercase;letter-spacing:.08em;color:#2563eb;font-weight:800;">Акция</div>
<div style="font-size:21px;line-height:28px;color:#111827;font-weight:800;margin-top:6px;">{{campaign_title}}</div>
<div style="font-size:14px;line-height:23px;color:#4b5563;margin-top:8px;">{{campaign_description}}</div>
</td>
</tr>
</table>

<table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="margin-top:20px;border-radius:12px;background:#2563eb;">
<tr>
<td align="center" style="padding:24px 18px;">
<div style="font-size:13px;line-height:18px;color:#dbeafe;font-weight:700;">Ваш промокод</div>
<div style="font-size:30px;line-height:38px;color:#ffffff;font-weight:900;letter-spacing:3px;margin-top:6px;">{{coupon_code}}</div>
<div style="font-size:14px;line-height:20px;color:#dbeafe;margin-top:6px;">Выгода: {{discount_value}}</div>
</td>
</tr>
</table>

<div style="text-align:center;margin:24px 0 10px;">
<a href="{{company_website}}" style="display:inline-block;background:#0f172a;color:#ffffff;text-decoration:none;font-size:15px;font-weight:800;padding:14px 28px;border-radius:10px;">Перейти на сайт</a>
</div>

<p style="margin:16px 0 0;font-size:12px;line-height:20px;color:#6b7280;text-align:center;">Если кнопка не открывается, перейдите на сайт: {{company_website}}</p>
</td>
</tr>

<tr>
<td style="padding:22px 28px;background:#f8fafc;text-align:center;border-top:1px solid #e5e7eb;">
<div style="font-size:14px;line-height:22px;color:#111827;font-weight:800;">{{company_name}}</div>
<div style="font-size:12px;line-height:20px;color:#6b7280;margin-top:6px;">
Телефон: {{company_phone}} · Email: {{company_email}}<br>
{{company_website}}<br><br>
© {{current_year}} {{company_name}}
</div>
</td>
</tr>
</table>
</td>
</tr>
</table>
</body>
</html>`;

const buildProfessionalBirthdayEmailTemplate = (t) => `<!doctype html>
<html lang="ru">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<meta name="color-scheme" content="light">
<title>${t("marketing_birthday_email_title")}</title>
</head>
<body style="margin:0;padding:0;background:#f3f6fb;font-family:Arial,Helvetica,sans-serif;color:#172033;">
<div data-vcrm-preheader="true" style="display:none;max-height:0;overflow:hidden;opacity:0;">${t("marketing_birthday_email_preheader")}</div>
<table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;background:#f3f6fb;padding:28px 12px;">
<tr>
<td align="center">
<table width="600" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;max-width:600px;background:#ffffff;border:1px solid #e4eaf2;border-radius:20px;overflow:hidden;box-shadow:0 12px 32px rgba(15,23,42,.08);">
<tr>
<td style="height:7px;background:{{company_primary_color}};font-size:0;line-height:0;">&nbsp;</td>
</tr>
<tr>
<td style="padding:25px 34px 20px;text-align:center;">
{{company_logo_img}}
<div style="margin-top:10px;font-size:18px;line-height:24px;font-weight:800;color:#172033;">{{company_name}}</div>
</td>
</tr>
<tr>
<td style="padding:8px 34px 32px;text-align:center;">
<div style="display:inline-block;padding:7px 12px;border-radius:999px;background:#eef4ff;color:{{company_primary_color}};font-size:11px;line-height:16px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;">${t("marketing_birthday_email_kicker")}</div>
<h1 style="margin:18px 0 12px;font-size:31px;line-height:39px;color:#172033;font-weight:850;">${t("marketing_birthday_email_greeting")} {{contact_first_name}}! 🎉</h1>
<p style="margin:0 auto;max-width:490px;font-size:16px;line-height:26px;color:#526076;">${t("marketing_birthday_email_intro")}</p>
<p style="margin:12px auto 0;max-width:490px;font-size:15px;line-height:25px;color:#526076;">${t("marketing_birthday_email_wish")}</p>
</td>
</tr>
<tr>
<td style="padding:0 34px 30px;">
<table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="border:1px solid #dce6f4;border-radius:16px;background:#f8fbff;">
<tr>
<td style="padding:24px 26px;text-align:center;">
<div style="font-size:12px;line-height:18px;color:{{company_primary_color}};font-weight:800;letter-spacing:.07em;text-transform:uppercase;">${t("marketing_birthday_email_gift_label")}</div>
<div style="margin-top:9px;font-size:16px;line-height:24px;color:#344054;">${t("marketing_birthday_email_discount_label")} <strong style="color:#172033;">{{discount_value}}</strong></div>
<div style="margin-top:18px;font-size:12px;line-height:18px;color:#667085;font-weight:700;">${t("marketing_birthday_email_promo_label")}</div>
<div style="display:inline-block;margin-top:7px;padding:11px 18px;border:1px dashed {{company_primary_color}};border-radius:10px;background:#ffffff;color:#172033;font-family:Consolas,Monaco,monospace;font-size:24px;line-height:30px;font-weight:900;letter-spacing:2px;">{{coupon_code}}</div>
<div style="margin-top:12px;font-size:12px;line-height:18px;color:#667085;">${t("marketing_birthday_email_valid_until")} {{coupon_valid_until}}</div>
</td>
</tr>
</table>
<div style="margin-top:24px;text-align:center;">
<a href="{{company_website}}" style="display:inline-block;padding:14px 28px;border-radius:11px;background:{{company_button_color}};color:#ffffff;text-decoration:none;font-size:15px;line-height:20px;font-weight:800;">${t("marketing_birthday_email_cta")}</a>
</div>
<p style="margin:14px 0 0;text-align:center;font-size:12px;line-height:19px;color:#7a8699;">${t("marketing_birthday_email_fallback")} {{company_website}}</p>
</td>
</tr>
<tr>
<td style="padding:22px 34px;background:#f8fafc;border-top:1px solid #e7ecf3;text-align:center;">
<div style="font-size:13px;line-height:20px;color:#344054;font-weight:700;">${t("marketing_birthday_email_regards")} {{company_name}}</div>
<div style="margin-top:7px;font-size:12px;line-height:19px;color:#7a8699;">{{company_phone}} · {{company_email}}<br>{{company_website}}<br>© {{current_year}} {{company_name}}</div>
</td>
</tr>
</table>
</td>
</tr>
</table>
</body>
</html>`;

const CRM_VARIABLE_GROUPS = [
  {
    title: "marketing_variables_company",
    items: [
      ["{{company_name}}", "marketing_variables_name"],
      ["{{company_logo_img}}", "marketing_variables_logo"],
      ["{{company_logo_url}}", "marketing_variables_logo_url"],
      ["{{company_phone}}", "marketing_variables_phone"],
      ["{{company_email}}", "marketing_channel_email_name"],
      ["{{company_website}}", "marketing_variables_website"],
      ["{{company_primary_color}}", "marketing_variables_brand_color"],
      ["{{company_button_color}}", "marketing_variables_button_color"],
    ],
  },
  {
    title: "marketing_variables_client",
    items: [
      ["{{contact_name}}", "marketing_variables_client_name"],
      ["{{contact_first_name}}", "marketing_variables_client_first_name"],
      ["{{contact_email}}", "marketing_variables_client_email"],
    ],
  },
  {
    title: "marketing_variables_campaign",
    items: [
      ["{{campaign_title}}", "marketing_campaign_name"],
      ["{{campaign_description}}", "description"],
      ["{{coupon_code}}", "marketing_variables_promo_code"],
      ["{{discount_value}}", "marketing_variables_discount"],
      ["{{coupon_valid_until}}", "marketing_variables_coupon_valid_until"],
    ],
  },
  {
    title: "marketing_variables_system",
    items: [["{{current_year}}", "marketing_variables_year"]],
  },
];

const KNOWN_MARKETING_VARIABLES = new Set(
  [
    ...CRM_VARIABLE_GROUPS.flatMap((group) =>
      group.items.map(([token]) => token)
    ),
    "{{company_logo}}",
  ]
);
const CAMPAIGN_DRAFT_KEY = "vcrm-marketing-campaign-draft-v3";
const EMAIL_PREHEADER_PATTERN =
  /<div\b[^>]*data-vcrm-preheader=["']true["'][^>]*>([\s\S]*?)<\/div>/i;

const escapeEmailPreheader = (value) =>
  String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");

const extractEmailPreheader = (htmlValue) => {
  const match = String(htmlValue || "").match(EMAIL_PREHEADER_PATTERN);
  if (!match) return "";
  return match[1]
    .replace(/<[^>]*>/g, "")
    .replaceAll("&lt;", "<")
    .replaceAll("&gt;", ">")
    .replaceAll("&amp;", "&")
    .trim();
};

const applyEmailPreheader = (htmlValue, preheaderValue) => {
  const source = String(htmlValue || "");
  const block = `<div data-vcrm-preheader="true" style="display:none;max-height:0;overflow:hidden;opacity:0;">${escapeEmailPreheader(
    preheaderValue
  )}</div>`;

  if (EMAIL_PREHEADER_PATTERN.test(source)) {
    return source.replace(EMAIL_PREHEADER_PATTERN, block);
  }
  if (/<body\b[^>]*>/i.test(source)) {
    return source.replace(/<body\b[^>]*>/i, (bodyTag) => `${bodyTag}\n${block}`);
  }
  return `${block}\n${source}`;
};

const normalizeCampaignDraftForm = (value) => {
  const source = value && typeof value === "object" ? value : {};
  const emailHtml = source.email_html ?? PROFESSIONAL_EMAIL_TEMPLATE;
  return {
    ...emptyCampaignForm,
    ...source,
    title: source.title || "",
    description: source.description || "",
    email_subject: source.email_subject || "",
    email_html: emailHtml,
    email_preheader:
      source.email_preheader ?? extractEmailPreheader(emailHtml),
    telegram_text: source.telegram_text || "",
    contact_ids: Array.isArray(source.contact_ids)
      ? source.contact_ids.map(Number).filter(Boolean)
      : [],
  };
};

const readCampaignDraft = () => {
  if (typeof window === "undefined") return null;
  try {
    const parsed = JSON.parse(window.localStorage.getItem(CAMPAIGN_DRAFT_KEY));
    if (!parsed?.form || !parsed?.saved_at) return null;
    const age = Date.now() - Number(parsed.saved_at);
    if (!Number.isFinite(age) || age > 30 * 24 * 60 * 60 * 1000) {
      window.localStorage.removeItem(CAMPAIGN_DRAFT_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

const getUnknownMarketingVariables = (form) => {
  const source = [
    form.email_subject,
    form.email_preheader,
    form.email_html,
    form.telegram_text,
  ].join("\n");
  const matches = source.match(/\{\{[a-zA-Z0-9_.:-]+\}\}/g) || [];
  return [...new Set(matches.filter((token) => !KNOWN_MARKETING_VARIABLES.has(token)))];
};

const emptyCampaignForm = {
  title: "",
  description: "",
  campaign_type: "global",
  trigger_type: "immediate",
  delivery_channel: "both",
  starts_at: "",
  ends_at: "",
  scheduled_at: "",
  email_subject: "",
  email_preheader: "Персональное предложение от {{company_name}}.",
  email_html: PROFESSIONAL_EMAIL_TEMPLATE,
  telegram_text: "🎁 Для вас доступна акция! Ваш промокод: {{coupon_code}}",
  coupon_type: "personal",
  coupon_discount_type: "percent",
  coupon_discount_value: "10",
  birthday_coupon_valid_days: 7,
  daily_email_limit: 300,
  generate_coupons: true,
  auto_start: false,
  auto_delete_enabled: true,
  delete_after_days: 30,
  contact_ids: [],
};

const emptyCouponForm = {
  code: "",
  contact_id: "",
  campaign_id: "",
  coupon_type: "gift",
  discount_type: "percent",
  discount_value: "10",
  starts_at: "",
  ends_at: "",
};

const dateToApi = (value) => {
  if (!value) return null;
  return value.length === 16 ? `${value}:00` : value;
};

const nowForDateTimeLocal = () => {
  const now = new Date();
  now.setSeconds(0, 0);
  const offsetMs = now.getTimezoneOffset() * 60 * 1000;
  return new Date(now.getTime() - offsetMs).toISOString().slice(0, 16);
};

const addDaysToDateTimeLocal = (value, days = 1) => {
  const source = value ? new Date(value) : new Date();
  if (Number.isNaN(source.getTime())) return nowForDateTimeLocal();
  source.setDate(source.getDate() + Number(days || 0));
  source.setSeconds(0, 0);
  const offsetMs = source.getTimezoneOffset() * 60 * 1000;
  return new Date(source.getTime() - offsetMs).toISOString().slice(0, 16);
};

const normalizeDateTimeInput = (value) => {
  if (!value) return "";
  return String(value).slice(0, 16);
};

const getCampaignStat = (campaign, channel, status) =>
  Number(
    campaign?.stats?.[channel]?.[status] ??
      campaign?.stats?.[`${channel}_${status}`] ??
      0
  );

const getCampaignCouponsUsed = (campaign) =>
  Number(
    campaign?.stats?.used_coupons ??
      campaign?.stats?.coupons_used ??
      0
  );

const getDeliveryStatusLabel = (status, channel, t) => {
  if (!status) return "—";
  if (channel === "email" && status === "sent") {
    return t("marketing_status_smtp_accepted");
  }
  return t(`marketing_status_${status}`, { defaultValue: status });
};

const getDeliveryErrorText = (value, t) => {
  if (value === "Telegram bot is not connected: chat_id is missing") {
    return t("marketing_error_telegram_bot_not_connected");
  }
  if (value === "Email not available") {
    return t("marketing_error_email_not_available");
  }
  return value || "";
};

const normalizeBirthDate = (value) => {
  const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : "";
};

const getContactBirthDate = (contact) => {
  const values = contact?.custom_field_values || {};
  for (const key of BIRTHDAY_FIELD_KEYS) {
    const normalized = normalizeBirthDate(values[key]);
    if (normalized) return normalized;
  }
  return "";
};

const formatBirthDate = (value) => {
  const normalized = normalizeBirthDate(value);
  if (!normalized) return "—";
  const [year, month, day] = normalized.split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString();
};

const compareDateTimeLocal = (a, b) => {
  if (!a || !b) return 0;
  const left = normalizeDateTimeInput(a);
  const right = normalizeDateTimeInput(b);
  if (left < right) return -1;
  if (left > right) return 1;
  return 0;
};


const getApiErrorText = (error, fallback = "") => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => item?.msg || item?.message || JSON.stringify(item))
      .join(", ");
  }
  if (detail && typeof detail === "object") {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return error?.message || fallback;
};

const addDays = (dateValue, days) => {
  if (!dateValue) return null;
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return null;
  date.setDate(date.getDate() + Number(days || 0));
  return date;
};

const isPastDate = (value) => {
  if (!value) return false;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return false;
  return date.getTime() < Date.now();
};

const getDeleteAfterDays = (campaign) => {
  const value = Number(campaign?.delete_after_days ?? 30);
  return Number.isFinite(value) && value >= 0 ? value : 30;
};

const getDeleteAfterDate = (campaign) => {
  if (!campaign) return null;
  if (campaign.delete_after_at) {
    const date = new Date(campaign.delete_after_at);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const base = campaign.archived_at || campaign.ends_at;
  return addDays(base, getDeleteAfterDays(campaign));
};

const isPendingDeleteCampaign = (campaign) => {
  const status = campaign?.status;
  if (["expired", "pending_delete", "cancelled", "completed"].includes(status)) return true;
  return isPastDate(campaign?.ends_at);
};

const getDaysUntilDelete = (campaign) => {
  if (campaign?.auto_delete_enabled === false) return null;
  const deleteAt = getDeleteAfterDate(campaign);
  if (!deleteAt) return null;
  return Math.max(0, Math.ceil((deleteAt.getTime() - Date.now()) / 86400000));
};

const canShowInContacts = (campaign) => !isPendingDeleteCampaign(campaign);

const patchCampaign = async (campaignId, payload) => {
  try {
    const { data } = await api.patch(`/marketing/campaigns/${campaignId}`, payload);
    return data;
  } catch (patchError) {
    if (![404, 405].includes(patchError?.response?.status)) throw patchError;
    const { data } = await api.put(`/marketing/campaigns/${campaignId}`, payload);
    return data;
  }
};

const getCampaignDateRules = (form) => {
  const now = nowForDateTimeLocal();
  const trigger = form.trigger_type || "immediate";

  const scheduledAt =
    trigger === "scheduled"
      ? normalizeDateTimeInput(form.scheduled_at)
      : "";

  const effectiveStartAt =
    trigger === "immediate"
      ? now
      : normalizeDateTimeInput(form.starts_at);

  const startsAt = normalizeDateTimeInput(form.starts_at);
  const endsAt = normalizeDateTimeInput(form.ends_at);

  const startMin = trigger === "scheduled" ? scheduledAt || now : now;
  const endMin = addDaysToDateTimeLocal(effectiveStartAt || startMin, 1);

  return {
    now,
    scheduledAt,
    startsAt,
    effectiveStartAt,
    endsAt,
    startMin,
    endMin,
    canPickStart: trigger !== "immediate" && (trigger !== "scheduled" || Boolean(scheduledAt)),
    canPickEnd: trigger === "immediate" || Boolean(startsAt),
  };
};

const formatDate = (value) => {
  if (!value) return "—";
  try {
    return new Intl.DateTimeFormat("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(value));
  } catch {
    return value;
  }
};

const getStatusTone = (status) => {
  if (["completed", "sent", "used", "active"].includes(status)) return "good";
  if (["scheduled", "pending", "processing", "queued", "sending"].includes(status)) return "warn";
  if (["failed", "cancelled", "expired", "pending_delete"].includes(status)) return "bad";
  return "neutral";
};

const buildCampaignPayload = (form) => {
  const isBirthday = form.trigger_type === "birthday";
  const isPersonalBirthday =
    isBirthday && form.campaign_type === "personal";

  return {
    title: form.title.trim(),
    description: form.description?.trim() || null,
    campaign_type: form.campaign_type,
    trigger_type: form.trigger_type,
    delivery_channel: form.delivery_channel,
    starts_at: isBirthday
      ? null
      : dateToApi(
          form.trigger_type === "immediate" && !form.starts_at
            ? nowForDateTimeLocal()
            : form.starts_at
        ),
    ends_at: isBirthday ? null : dateToApi(form.ends_at),
    scheduled_at:
      !isBirthday && form.trigger_type === "scheduled"
        ? dateToApi(form.scheduled_at)
        : null,
    email_subject:
      form.delivery_channel !== "telegram"
        ? form.email_subject?.trim() || form.title
        : null,
    email_html:
      form.delivery_channel !== "telegram"
        ? applyEmailPreheader(form.email_html, form.email_preheader)
        : null,
    telegram_text:
      form.delivery_channel !== "email" ? form.telegram_text : null,
    coupon_type: form.generate_coupons ? form.coupon_type : null,
    coupon_discount_type: form.generate_coupons
      ? form.coupon_discount_type
      : null,
    coupon_discount_value:
      form.generate_coupons && form.coupon_discount_value !== ""
        ? Number(form.coupon_discount_value)
        : null,
    birthday_coupon_valid_days: Number(
      form.birthday_coupon_valid_days || 7
    ),
    daily_email_limit: Number(form.daily_email_limit || 300),
    generate_coupons: Boolean(form.generate_coupons),
    auto_start: isBirthday || Boolean(form.auto_start),
    auto_delete_enabled: isBirthday
      ? false
      : Boolean(form.auto_delete_enabled),
    delete_after_days: Number(form.delete_after_days || 30),
    contact_ids: isPersonalBirthday
      ? (form.contact_ids || []).map(Number).filter(Boolean)
      : [],
  };
};

function StatusPill({ status, label }) {
  const { t } = useTranslation();
  const value = status || "draft";
  return (
    <span className={`vcrm-pill ${getStatusTone(status)}`}>
      <span />
      {label || t(`marketing_status_${value}`, { defaultValue: value })}
    </span>
  );
}

function Metric({ label, value, note }) {
  return (
    <div className="vcrm-metric">
      <span>{label}</span>
      <strong>{value}</strong>
      {note && <small>{note}</small>}
    </div>
  );
}

function EmptyState({ title, text, action }) {
  return (
    <div className="vcrm-empty">
      <div className="vcrm-emptyIcon">✦</div>
      <strong>{title}</strong>
      {text && <p>{text}</p>}
      {action}
    </div>
  );
}

function Drawer({ title, subtitle, children, footer, onClose, wide = false }) {
  const { t } = useTranslation();
  return (
    <div className="vcrm-drawerBackdrop" onMouseDown={onClose}>
      <aside
        data-academy="marketing-campaign-drawer"
        className={`vcrm-drawer ${wide ? "wide" : ""}`}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="vcrm-drawerHeader">
          <div>
            <h2>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button
            data-academy="marketing-campaign-drawer-close"
            className="vcrm-iconButton"
            type="button"
            onClick={onClose}
            aria-label={t("close")}
          >
            ×
          </button>
        </header>

        <div className="vcrm-drawerBody">{children}</div>

        {footer && <footer className="vcrm-drawerFooter">{footer}</footer>}
      </aside>
    </div>
  );
}

function ConfirmDialog({
  open,
  title,
  text,
  confirmLabel,
  cancelLabel,
  danger = false,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") onCancel?.();
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [open, onCancel]);

  if (!open || typeof document === "undefined") return null;
  return createPortal(
    <div
      className="vcrm-confirmBackdrop"
      role="presentation"
      onMouseDown={onCancel}
    >
      <section
        className="vcrm-confirmDialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="vcrm-confirm-title"
        aria-describedby="vcrm-confirm-text"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className={`vcrm-confirmIcon ${danger ? "isDanger" : ""}`}>
          {danger ? "!" : "?"}
        </div>
        <h3 id="vcrm-confirm-title">{title}</h3>
        <p id="vcrm-confirm-text">{text}</p>
        <footer>
          <button className="vcrm-btn secondary" type="button" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            className={`vcrm-btn ${danger ? "danger" : "primary"}`}
            type="button"
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
        </footer>
      </section>
    </div>,
    document.body
  );
}

function Field({ label, children, full = false, error = "" }) {
  return (
    <label
      className={`vcrm-field ${full ? "full" : ""} ${
        error ? "hasError" : ""
      }`}
    >
      <span>{label}</span>
      {children}
      {error && <small className="vcrm-fieldError">{error}</small>}
    </label>
  );
}

function CampaignCard({ campaign, onOpen }) {
  const { t } = useTranslation();
  const sent =
    getCampaignStat(campaign, "email", "sent") +
    getCampaignStat(campaign, "telegram", "sent");
  const channelLabel = CHANNEL_LABELS[campaign.delivery_channel]
    ? t(CHANNEL_LABELS[campaign.delivery_channel])
    : campaign.delivery_channel || "—";
  const triggerLabel = TRIGGER_LABELS[campaign.trigger_type]
    ? t(TRIGGER_LABELS[campaign.trigger_type])
    : campaign.trigger_type || "—";

  return (
    <button className="vcrm-campaignCard" type="button" onClick={onOpen}>
      <div className="vcrm-campaignTop">
        <div className="vcrm-campaignIcon">{campaign.campaign_type === "personal" ? "🎁" : "🏷️"}</div>
        <StatusPill status={campaign.status} />
      </div>

      <h3>{campaign.title || t("marketing_untitled")}</h3>
      <p>{campaign.description || t("marketing_no_description_open_hint")}</p>

      <div className="vcrm-cardMeta">
        <span>{channelLabel}</span>
        <span>{triggerLabel}</span>
      </div>

      {isPendingDeleteCampaign(campaign) && (
        <div className="vcrm-deleteNotice">
          {t("marketing_pending_deletion")}{getDaysUntilDelete(campaign) !== null ? ` ${t("marketing_in_days", { count: getDaysUntilDelete(campaign) })}` : ""}
        </div>
      )}

      <div className="vcrm-cardFooter">
        <span>
          {campaign.trigger_type === "birthday"
            ? t("marketing_birthday_daily_midnight")
            : formatDate(
                campaign.scheduled_at ||
                  campaign.starts_at ||
                  campaign.ends_at
              )}
        </span>
        <strong>{sent} {t("marketing_sent_lower")}</strong>
      </div>
    </button>
  );
}


function ArchiveCampaignCard({ campaign, onOpen }) {
  const { t } = useTranslation();
  const sent =
    getCampaignStat(campaign, "email", "sent") +
    getCampaignStat(campaign, "telegram", "sent");
  const days = getDaysUntilDelete(campaign);
  const expired = isPastDate(campaign?.ends_at);
  const cancelled = campaign?.status === "cancelled";
  const deleteDate = getDeleteAfterDate(campaign);

  let stateLabel = t("marketing_in_archive");
  if (cancelled) stateLabel = t("marketing_status_cancelled");
  else if (expired) stateLabel = t("marketing_status_expired");
  else if (campaign?.status === "completed") stateLabel = t("marketing_status_completed");

  return (
    <button className="vcrm-archiveCard" type="button" onClick={onOpen}>
      <div className="vcrm-archiveCardIcon">{campaign.campaign_type === "personal" ? "🎁" : "🏷️"}</div>

      <div className="vcrm-archiveCardMain">
        <div className="vcrm-archiveCardTop">
          <h3>{campaign.title || t("marketing_untitled")}</h3>
          <StatusPill status={campaign.status || "draft"} />
        </div>

        <p>{campaign.description || t("marketing_no_description_open_hint")}</p>

        <div className="vcrm-archiveCardMeta">
          <span>
            {CHANNEL_LABELS[campaign.delivery_channel]
              ? t(CHANNEL_LABELS[campaign.delivery_channel])
              : campaign.delivery_channel || "—"}
          </span>
          <span>
            {TRIGGER_LABELS[campaign.trigger_type]
              ? t(TRIGGER_LABELS[campaign.trigger_type])
              : campaign.trigger_type || "—"}
          </span>
          <span>{sent} {t("marketing_sent_lower")}</span>
        </div>
      </div>

      <div className="vcrm-archiveCardSide">
        <strong>{stateLabel}</strong>
        <span>{t("marketing_ended")} {formatDate(campaign.ends_at)}</span>
        <span>{t("marketing_deletion")} {campaign.auto_delete_enabled === false ? t("disabled") : days !== null ? t("marketing_in_days", { count: days }) : formatDate(deleteDate)}</span>
        <em>{t("marketing_open_details")}</em>
      </div>
    </button>
  );
}

function QuickActions({ onTemplate }) {
  const { t } = useTranslation();
  return (
    <section className="vcrm-panel vcrm-quickPanel">
      <div className="vcrm-panelHead compact">
        <div>
          <h2>{t("marketing_quick_scenarios")}</h2>
          <p>{t("marketing_quick_scenarios_hint")}</p>
        </div>
      </div>

      <div className="vcrm-quickGrid">
        {QUICK_TEMPLATES.map((template) => (
          <button key={template.key} type="button" onClick={() => onTemplate(template)}>
            <strong>{t(template.title)}</strong>
            <span>{t(template.description)}</span>
          </button>
        ))}
      </div>
    </section>
  );
}

const escapeEmailPreviewValue = (value) =>
  String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");

const buildEmailPreviewHtml = (form, t) => {
  let html = form.email_html || t("marketing_email_preview_fallback");
  const discountValue = form.coupon_discount_value
    ? `${form.coupon_discount_value}${
        form.coupon_discount_type === "percent" ? "%" : ""
      }`
    : "10%";
  const previewLogo = `<div style="display:inline-flex;align-items:center;justify-content:center;min-width:112px;height:42px;padding:0 16px;border-radius:10px;background:#172033;color:#ffffff;font:800 13px/1 Arial,sans-serif;letter-spacing:.08em;text-transform:uppercase;">${escapeEmailPreviewValue(
    t("marketing_preview_logo")
  )}</div>`;

  const replacements = {
    "{{company_logo_img}}": previewLogo,
    "{{company_logo_url}}": "",
    "{{company_logo}}": "",
    "{{company_name}}": escapeEmailPreviewValue(
      t("marketing_preview_company_name")
    ),
    "{{company_phone}}": "+372 5555 5555",
    "{{company_email}}": "hello@example.com",
    "{{company_website}}": "https://example.com",
    "{{company_primary_color}}": "#2563eb",
    "{{company_button_color}}": "#2563eb",
    "{{contact_name}}": escapeEmailPreviewValue(
      t("marketing_preview_contact_name")
    ),
    "{{contact_first_name}}": escapeEmailPreviewValue(
      t("marketing_preview_contact_first_name")
    ),
    "{{contact_email}}": "client@example.com",
    "{{campaign_title}}": escapeEmailPreviewValue(
      form.title || t("marketing_email_subject_fallback")
    ),
    "{{campaign_description}}": escapeEmailPreviewValue(
      form.description || t("marketing_preview_campaign_description")
    ),
    "{{coupon_code}}": "BDAY-2026",
    "{{coupon_valid_until}}": "31.12.2026",
    "{{discount_value}}": escapeEmailPreviewValue(discountValue),
    "{{current_year}}": String(new Date().getFullYear()),
  };

  Object.entries(replacements).forEach(([token, value]) => {
    html = html.split(token).join(value);
  });

  return html;
};

function ExpandPreviewIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M8 3H3v5M16 3h5v5M8 21H3v-5M21 16v5h-5" />
    </svg>
  );
}

function ClosePreviewIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="m6 6 12 12M18 6 6 18" />
    </svg>
  );
}

function CampaignPreview({ form, onEmailHtmlChange }) {
  const { t } = useTranslation();
  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  const [fullscreenMode, setFullscreenMode] = useState("preview");
  const [previewViewport, setPreviewViewport] = useState("desktop");
  const showEmail = form.delivery_channel !== "telegram";
  const showTelegram = form.delivery_channel !== "email";
  const emailPreviewHtml = useMemo(
    () => buildEmailPreviewHtml(form, t),
    [form, t]
  );

  useEffect(() => {
    if (!fullscreenOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setFullscreenOpen(false);
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", closeOnEscape);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [fullscreenOpen]);

  const fullscreenPreview =
    fullscreenOpen && typeof document !== "undefined"
      ? createPortal(
          <div
            data-academy="marketing-fullscreen-preview"
            className="vcrm-emailFullscreen"
            role="dialog"
            aria-modal="true"
            aria-label={t("marketing_fullscreen_email_preview")}
          >
            <header className="vcrm-emailFullscreenHeader">
              <div className="vcrm-emailFullscreenTitle">
                <span>{t("marketing_email_preview_title")}</span>
                <strong>
                  {form.email_subject ||
                    form.title ||
                    t("marketing_email_subject_fallback")}
                </strong>
              </div>

              <div
                data-academy="marketing-fullscreen-modes"
                className="vcrm-emailFullscreenTabs"
                role="tablist"
                aria-label={t("marketing_email_preview_mode")}
              >
                {[
                  ["preview", "marketing_preview_mode_visual"],
                  ["code", "marketing_preview_mode_code"],
                  ["split", "marketing_preview_mode_split"],
                ].map(([mode, label]) => (
                  <button
                    className={fullscreenMode === mode ? "active" : ""}
                    key={mode}
                    type="button"
                    role="tab"
                    aria-selected={fullscreenMode === mode}
                    onClick={() => setFullscreenMode(mode)}
                  >
                    {t(label)}
                  </button>
                ))}
              </div>

              <div className="vcrm-emailFullscreenActions">
                {fullscreenMode !== "code" && (
                  <div
                    data-academy="marketing-fullscreen-device-switch"
                    className="vcrm-emailViewportSwitch"
                    aria-label={t("marketing_preview_width")}
                  >
                    <button
                      className={previewViewport === "desktop" ? "active" : ""}
                      type="button"
                      onClick={() => setPreviewViewport("desktop")}
                    >
                      {t("marketing_preview_desktop")}
                    </button>
                    <button
                      className={previewViewport === "mobile" ? "active" : ""}
                      type="button"
                      onClick={() => setPreviewViewport("mobile")}
                    >
                      {t("marketing_preview_mobile")}
                    </button>
                  </div>
                )}

                <button
                  data-academy="marketing-fullscreen-preview-close"
                  className="vcrm-emailFullscreenClose"
                  type="button"
                  onClick={() => setFullscreenOpen(false)}
                  aria-label={t("close")}
                  title={t("close")}
                >
                  <ClosePreviewIcon />
                </button>
              </div>
            </header>

            <div className="vcrm-emailFullscreenHint">
              {t("marketing_preview_demo_variables_hint")}
            </div>

            <main
              className={`vcrm-emailFullscreenBody mode-${fullscreenMode}`}
            >
              {fullscreenMode !== "code" && (
                <section className="vcrm-emailVisualPane">
                  <div
                    className={`vcrm-emailViewport is-${previewViewport}`}
                  >
                    <iframe
                      title={t("marketing_fullscreen_email_preview")}
                      sandbox=""
                      srcDoc={emailPreviewHtml}
                    />
                  </div>
                </section>
              )}

              {fullscreenMode !== "preview" && (
                <section className="vcrm-emailCodePane">
                  <div className="vcrm-emailCodeHeader">
                    <strong>HTML</strong>
                    <span>{t("marketing_code_changes_live")}</span>
                  </div>
                  <textarea
                    value={form.email_html || ""}
                    onChange={(event) =>
                      onEmailHtmlChange?.(event.target.value)
                    }
                    aria-label={t("marketing_email_html")}
                    spellCheck={false}
                  />
                </section>
              )}
            </main>
          </div>,
          document.body
        )
      : null;

  return (
    <>
      <div className="vcrm-previewPhone">
        <div className="vcrm-previewBar">
          <span />
          <span />
          <span />
        </div>

        {showEmail && (
          <div className="vcrm-previewBlock vcrm-emailPreviewBlock">
            <div className="vcrm-previewBlockHeader">
              <div className="vcrm-previewLabel">
                {t("marketing_email_channel")}
              </div>
              <div
                data-academy="marketing-preview-device-switch"
                className="vcrm-previewViewportSwitch"
                aria-label={t("marketing_preview_width")}
              >
                <button
                  className={previewViewport === "desktop" ? "active" : ""}
                  type="button"
                  onClick={() => setPreviewViewport("desktop")}
                  title={t("marketing_preview_desktop")}
                >
                  {t("marketing_preview_desktop_short")}
                </button>
                <button
                  className={previewViewport === "mobile" ? "active" : ""}
                  type="button"
                  onClick={() => setPreviewViewport("mobile")}
                  title={t("marketing_preview_mobile")}
                >
                  {t("marketing_preview_mobile_short")}
                </button>
              </div>
            </div>
            <button
              data-academy="marketing-preview-fullscreen"
              className="vcrm-expandEmailPreview"
              type="button"
              onClick={() => {
                setFullscreenMode("preview");
                setFullscreenOpen(true);
              }}
              aria-label={t("marketing_open_fullscreen_preview")}
              title={t("marketing_open_fullscreen_preview")}
            >
              <ExpandPreviewIcon />
            </button>
            <strong>
              {form.email_subject ||
                form.title ||
                t("marketing_email_subject_fallback")}
            </strong>
            <div
              className={`vcrm-emailPreviewViewport is-${previewViewport}`}
            >
              <iframe
                className="vcrm-emailPreview"
                title={t("marketing_email_preview_title")}
                sandbox=""
                srcDoc={emailPreviewHtml}
              />
            </div>
          </div>
        )}

        {showTelegram && (
          <div className="vcrm-previewBlock telegram">
            <div className="vcrm-previewLabel">
              {t("marketing_telegram_channel")}
            </div>
            <p>
              {form.telegram_text ||
                t("marketing_telegram_preview_fallback")}
            </p>
          </div>
        )}
      </div>
      {fullscreenPreview}
    </>
  );
}


function CampaignDrawer({
  initialForm,
  globalBirthdayExists,
  onClose,
  onCreated,
}) {
  const { t } = useTranslation();
  const [savedDraft] = useState(() => readCampaignDraft());
  const [draftOffer, setDraftOffer] = useState(savedDraft);
  const [form, setForm] = useState(() =>
    normalizeCampaignDraftForm(initialForm || emptyCampaignForm)
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [isDirty, setIsDirty] = useState(false);
  const [draftSavedAt, setDraftSavedAt] = useState(null);
  const [confirmAction, setConfirmAction] = useState("");
  const [contactQuery, setContactQuery] = useState("");
  const [birthdayContacts, setBirthdayContacts] = useState([]);
  const [birthdayContactsLoading, setBirthdayContactsLoading] = useState(false);
  const [birthdayContactsError, setBirthdayContactsError] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [highestStep, setHighestStep] = useState(0);
  const [audienceReadiness, setAudienceReadiness] = useState(null);
  const [audienceLoading, setAudienceLoading] = useState(false);
  const [audienceError, setAudienceError] = useState("");
  const [summaryOpen, setSummaryOpen] = useState(true);
  const [testPanelOpen, setTestPanelOpen] = useState(false);
  const [testEmail, setTestEmail] = useState("");
  const [testTelegramChatId, setTestTelegramChatId] = useState("");
  const [testSending, setTestSending] = useState(false);
  const [testResult, setTestResult] = useState({ tone: "", text: "" });
  const [academyMode, setAcademyMode] = useState(false);
  const emailEditorRef = useRef(null);
  const wizardTopRef = useRef(null);
  const fieldRefs = useRef({});
  const emailHistoryRef = useRef([]);
  const lastEmailHistoryAtRef = useRef(0);
  const academyScenarioRef = useRef("");

  const isBirthday = form.trigger_type === "birthday";
  const isGlobalBirthday =
    isBirthday && form.campaign_type === "global";
  const isPersonalBirthday =
    isBirthday && form.campaign_type === "personal";
  const globalBirthdayConflict =
    isGlobalBirthday && Boolean(globalBirthdayExists);
  const selectedBirthdayContactId = Number(form.contact_ids?.[0] || 0);
  const selectedBirthdayContact = birthdayContacts.find(
    (contact) => Number(contact.id) === selectedBirthdayContactId
  );

  useEffect(() => {
    const drawerBody = wizardTopRef.current?.closest(".vcrm-drawerBody");
    drawerBody?.scrollTo({ top: 0, behavior: "smooth" });
  }, [activeStep]);

  useEffect(() => {
    const showAcademyStep = (event) => {
      const nextStep = Number(event?.detail?.step);
      if (
        !Number.isInteger(nextStep) ||
        nextStep < 0 ||
        nextStep > CAMPAIGN_WIZARD_LAST_STEP
      ) {
        return;
      }

      setError("");
      setFieldErrors({});
      setHighestStep((current) => Math.max(current, nextStep));
      setActiveStep(nextStep);
    };

    const showAcademyScenario = (event) => {
      const scenario = String(event?.detail?.scenario || "");
      const requestedStep = Number(event?.detail?.step);
      const nextStep =
        Number.isInteger(requestedStep) &&
        requestedStep >= 0 &&
        requestedStep <= CAMPAIGN_WIZARD_LAST_STEP
          ? requestedStep
          : 0;

      if (
        scenario !== "global" &&
        scenario !== "birthday"
      ) {
        return;
      }

      if (academyScenarioRef.current !== scenario) {
        const isBirthdayScenario = scenario === "birthday";
        const sendAt = addDaysToDateTimeLocal(nowForDateTimeLocal(), 1);
        const emailHtml = isBirthdayScenario
          ? buildProfessionalBirthdayEmailTemplate(t)
          : PROFESSIONAL_EMAIL_TEMPLATE;

        setForm(
          normalizeCampaignDraftForm({
            ...emptyCampaignForm,
            title: t(
              isBirthdayScenario
                ? "academy_marketing_birthday_sample_title"
                : "academy_marketing_global_sample_title"
            ),
            description: t(
              isBirthdayScenario
                ? "marketing_template_global_birthday_description"
                : "marketing_template_sale_description"
            ),
            campaign_type: "global",
            delivery_channel: "both",
            trigger_type: isBirthdayScenario ? "birthday" : "scheduled",
            scheduled_at: isBirthdayScenario ? "" : sendAt,
            starts_at: isBirthdayScenario ? "" : sendAt,
            ends_at: isBirthdayScenario
              ? ""
              : addDaysToDateTimeLocal(sendAt, 7),
            birthday_coupon_valid_days: 14,
            email_subject: t(
              isBirthdayScenario
                ? "marketing_template_birthday_email_subject"
                : "marketing_template_sale_email_subject"
            ),
            email_preheader: t(
              isBirthdayScenario
                ? "marketing_birthday_email_preheader"
                : "academy_marketing_global_sample_preheader"
            ),
            email_html: emailHtml,
            telegram_text: t(
              isBirthdayScenario
                ? "marketing_template_birthday_telegram"
                : "marketing_template_sale_telegram"
            ),
            generate_coupons: true,
            coupon_type: isBirthdayScenario ? "birthday" : "public",
            coupon_discount_type: "percent",
            coupon_discount_value: 10,
            daily_email_limit: 100,
            auto_start: true,
            auto_delete_enabled: !isBirthdayScenario,
            delete_after_days: 30,
            contact_ids: [],
          })
        );
        academyScenarioRef.current = scenario;
        emailHistoryRef.current = [];
        setDraftOffer(null);
        setDraftSavedAt(null);
        setIsDirty(false);
        setAcademyMode(true);
        setSummaryOpen(true);
        setTestPanelOpen(false);
        setTestResult({ tone: "", text: "" });
      }

      setError("");
      setFieldErrors({});
      setHighestStep(CAMPAIGN_WIZARD_LAST_STEP);
      setActiveStep(nextStep);
    };

    const closeAcademyScenario = () => {
      onClose();
    };

    window.addEventListener(
      "vcrm:academy-marketing-step",
      showAcademyStep
    );
    window.addEventListener(
      "vcrm:academy-marketing-scenario",
      showAcademyScenario
    );
    window.addEventListener(
      "vcrm:academy-marketing-cleanup",
      closeAcademyScenario
    );
    return () => {
      window.removeEventListener(
        "vcrm:academy-marketing-step",
        showAcademyStep
      );
      window.removeEventListener(
        "vcrm:academy-marketing-scenario",
        showAcademyScenario
      );
      window.removeEventListener(
        "vcrm:academy-marketing-cleanup",
        closeAcademyScenario
      );
    };
  }, [onClose, t]);

  useEffect(() => {
    if (
      academyMode ||
      !isDirty ||
      draftOffer ||
      typeof window === "undefined"
    ) {
      return undefined;
    }
    const timer = window.setTimeout(() => {
      window.localStorage.setItem(
        CAMPAIGN_DRAFT_KEY,
        JSON.stringify({
          form,
          active_step: activeStep,
          highest_step: highestStep,
          saved_at: Date.now(),
        })
      );
      setDraftSavedAt(new Date());
    }, 450);
    return () => window.clearTimeout(timer);
  }, [academyMode, activeStep, draftOffer, form, highestStep, isDirty]);

  useEffect(() => {
    if (!isDirty) return undefined;
    const warnBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", warnBeforeUnload);
    return () => window.removeEventListener("beforeunload", warnBeforeUnload);
  }, [isDirty]);

  useEffect(() => {
    setForm((prev) => {
      if ((prev.trigger_type || "immediate") !== "immediate") return prev;

      const start = prev.starts_at || nowForDateTimeLocal();
      const minEnd = addDaysToDateTimeLocal(start, 1);
      const hasValidEnd = prev.ends_at && compareDateTimeLocal(prev.ends_at, minEnd) >= 0;

      if (prev.starts_at === start && hasValidEnd) return prev;

      return {
        ...prev,
        starts_at: start,
        ends_at: hasValidEnd ? prev.ends_at : minEnd,
      };
    });
  }, [initialForm]);

  useEffect(() => {
    if (!isPersonalBirthday) {
      setBirthdayContacts([]);
      setBirthdayContactsLoading(false);
      setBirthdayContactsError("");
      return undefined;
    }

    let cancelled = false;
    const timer = window.setTimeout(async () => {
      setBirthdayContactsLoading(true);
      setBirthdayContactsError("");
      try {
        const query = contactQuery.trim();
        const { data } = await api.get("/contacts", {
          params: {
            skip: 0,
            limit: 50,
            ...(query ? { q: query } : {}),
          },
        });
        if (!cancelled) {
          setBirthdayContacts(Array.isArray(data?.items) ? data.items : []);
        }
      } catch (requestError) {
        console.error(requestError);
        if (!cancelled) {
          setBirthdayContacts([]);
          setBirthdayContactsError(t("marketing_birthday_contacts_load_failed"));
        }
      } finally {
        if (!cancelled) setBirthdayContactsLoading(false);
      }
    }, 250);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [contactQuery, isPersonalBirthday, t]);

  useEffect(() => {
    let cancelled = false;
    const timer = window.setTimeout(async () => {
      setAudienceLoading(true);
      setAudienceError("");
      try {
        const { data } = await api.post("/marketing/audience-readiness", {
          campaign_type: form.campaign_type,
          trigger_type: form.trigger_type,
          delivery_channel: form.delivery_channel,
          contact_ids: form.contact_ids || [],
        });
        if (!cancelled) setAudienceReadiness(data || null);
      } catch (requestError) {
        console.error(requestError);
        if (!cancelled) {
          setAudienceReadiness(null);
          setAudienceError(t("marketing_audience_readiness_failed"));
        }
      } finally {
        if (!cancelled) setAudienceLoading(false);
      }
    }, 350);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [
    form.campaign_type,
    form.contact_ids,
    form.delivery_channel,
    form.trigger_type,
    t,
  ]);

  const rememberEmailHtml = (value, force = false) => {
    const current = String(value || "");
    const history = emailHistoryRef.current;
    if (history[history.length - 1] === current) return;
    const now = Date.now();
    if (force || now - lastEmailHistoryAtRef.current > 700 || history.length === 0) {
      history.push(current);
      if (history.length > 40) history.shift();
    }
    lastEmailHistoryAtRef.current = now;
  };

  const update = (key, value) => {
    setError("");
    setIsDirty(true);
    setDraftSavedAt(null);
    setFieldErrors((current) => {
      if (!current[key]) return current;
      const next = { ...current };
      delete next[key];
      return next;
    });
    setForm((prev) => {
      const next = { ...prev, [key]: value };

      if (key === "email_html" && value !== prev.email_html) {
        rememberEmailHtml(prev.email_html);
        next.email_preheader =
          extractEmailPreheader(value) || prev.email_preheader || "";
      }

      if (key === "email_preheader") {
        next.email_html = applyEmailPreheader(prev.email_html, value);
      }

      if (key === "trigger_type") {
        next.scheduled_at = "";
        next.starts_at =
          value === "immediate" ? nowForDateTimeLocal() : "";
        next.ends_at =
          value === "immediate"
            ? addDaysToDateTimeLocal(next.starts_at, 1)
            : "";

        if (value === "birthday") {
          rememberEmailHtml(prev.email_html, true);
          next.starts_at = "";
          next.ends_at = "";
          next.birthday_coupon_valid_days = Number(
            next.birthday_coupon_valid_days || 7
          );
          next.auto_start = true;
          next.auto_delete_enabled = false;
          next.coupon_type = "birthday";
          next.generate_coupons = true;
          next.telegram_text = t("marketing_template_birthday_telegram");
          next.email_subject = t("marketing_template_birthday_email_subject");
          next.email_html = buildProfessionalBirthdayEmailTemplate(t);
          next.email_preheader = t("marketing_birthday_email_preheader");
          next.description =
            next.description || t("marketing_template_birthday_description");
        }
      }

      if (key === "campaign_type" && next.trigger_type === "birthday") {
        next.contact_ids = [];
        next.starts_at = "";
        next.ends_at = "";
        next.scheduled_at = "";
        next.birthday_coupon_valid_days = Number(
          next.birthday_coupon_valid_days || 7
        );
        next.auto_start = true;
        next.auto_delete_enabled = false;
        next.coupon_type = "birthday";
        if (value === "global") {
          rememberEmailHtml(prev.email_html, true);
          next.generate_coupons = true;
          next.description = t("marketing_template_global_birthday_description");
          next.telegram_text = t("marketing_template_birthday_telegram");
          next.email_subject = t("marketing_template_birthday_email_subject");
          next.email_html = buildProfessionalBirthdayEmailTemplate(t);
          next.email_preheader = t("marketing_birthday_email_preheader");
        }
      }

      if (key === "scheduled_at") {
        next.starts_at = "";
        next.ends_at = "";
      }

      if (key === "starts_at") {
        next.ends_at = value ? addDaysToDateTimeLocal(value, 1) : "";
      }

      return next;
    });
  };

  const applyProfessionalEmailTemplate = () => {
    setIsDirty(true);
    setDraftSavedAt(null);
    setForm((prev) => {
      rememberEmailHtml(prev.email_html, true);
      const emailHtml = isBirthday
        ? buildProfessionalBirthdayEmailTemplate(t)
        : PROFESSIONAL_EMAIL_TEMPLATE;
      return {
        ...prev,
        email_html: emailHtml,
        email_preheader: extractEmailPreheader(emailHtml),
        email_subject:
          prev.email_subject ||
          (isBirthday
            ? t("marketing_template_birthday_email_subject")
            : prev.title || t("marketing_special_offer_subject")),
      };
    });
  };

  const undoEmailHtml = () => {
    const previous = emailHistoryRef.current.pop();
    if (previous === undefined) return;
    setIsDirty(true);
    setDraftSavedAt(null);
    setError("");
    setForm((current) => ({
      ...current,
      email_html: previous,
      email_preheader:
        extractEmailPreheader(previous) || current.email_preheader || "",
    }));
  };

  const insertEmailVariable = (token) => {
    const editor = emailEditorRef.current;
    const source = form.email_html || "";
    const start = editor?.selectionStart ?? source.length;
    const end = editor?.selectionEnd ?? start;
    update(
      "email_html",
      `${source.slice(0, start)}${token}${source.slice(end)}`
    );

    window.requestAnimationFrame(() => {
      if (!editor) return;
      const nextPosition = start + token.length;
      editor.focus();
      editor.setSelectionRange(nextPosition, nextPosition);
    });
  };

  const dateRules = getCampaignDateRules(form);

  const getStepErrors = (step) => {
    const errors = {};
    const rules = getCampaignDateRules(form);
    const now = rules.now;

    if (step === 0) {
      if (!String(form.title || "").trim()) {
        errors.title = t("marketing_validation_title");
      }

      if (globalBirthdayConflict) {
        errors.campaign_type = t("marketing_global_birthday_exists");
      }

      if (!isBirthday && form.trigger_type === "scheduled") {
        if (!form.scheduled_at) {
          errors.scheduled_at = t("marketing_validation_schedule_date");
        } else if (compareDateTimeLocal(form.scheduled_at, now) < 0) {
          errors.scheduled_at = t("marketing_validation_schedule_past");
        }
      }

      if (
        !isBirthday &&
        form.trigger_type !== "immediate" &&
        form.starts_at
      ) {
        if (compareDateTimeLocal(form.starts_at, rules.startMin) < 0) {
          errors.starts_at = t("marketing_validation_start_before_send");
        }
      }

      if (!isBirthday && form.ends_at) {
        const endMinimum =
          form.trigger_type === "immediate" && form.starts_at
            ? addDaysToDateTimeLocal(form.starts_at, 1)
            : rules.endMin;
        if (!rules.canPickEnd) {
          errors.ends_at = t("marketing_validation_start_first");
        } else if (compareDateTimeLocal(form.ends_at, endMinimum) < 0) {
          errors.ends_at = t("marketing_validation_end_minimum");
        }
      }
      if (
        isBirthday &&
        form.generate_coupons &&
        (
          !Number.isInteger(Number(form.birthday_coupon_valid_days)) ||
          Number(form.birthday_coupon_valid_days) < 1 ||
          Number(form.birthday_coupon_valid_days) > 365
        )
      ) {
        errors.birthday_coupon_valid_days = t(
          "marketing_birthday_validity_validation"
        );
      }
    }

    if (step === 1) {
      if (
        form.delivery_channel !== "telegram" &&
        !String(form.email_html || "").trim()
      ) {
        errors.email_html = t("marketing_validation_email_template");
      }
      if (
        form.delivery_channel !== "email" &&
        !String(form.telegram_text || "").trim()
      ) {
        errors.telegram_text = t("marketing_validation_telegram_message");
      }
    }

    if (
      step === 2 &&
      isPersonalBirthday &&
      (form.contact_ids || []).length !== 1
    ) {
      errors.contact_ids = t("marketing_personal_birthday_contact_required");
    }

    if (step === 3) {
      if (
        form.auto_delete_enabled &&
        (
          !Number.isInteger(Number(form.delete_after_days)) ||
          Number(form.delete_after_days) < 1 ||
          Number(form.delete_after_days) > 365
        )
      ) {
        errors.delete_after_days = t(
          "marketing_delete_after_validation"
        );
      }
      if (
        form.generate_coupons &&
        form.coupon_discount_type !== "gift" &&
        (
          !Number.isFinite(Number(form.coupon_discount_value)) ||
          Number(form.coupon_discount_value) <= 0
        )
      ) {
        errors.coupon_discount_value = t(
          "marketing_discount_value_validation"
        );
      }
      if (
        !Number.isInteger(Number(form.daily_email_limit)) ||
        Number(form.daily_email_limit) < 1 ||
        Number(form.daily_email_limit) > 10000
      ) {
        errors.daily_email_limit = t("marketing_daily_limit_validation");
      }
    }

    return errors;
  };

  const validateAll = () => {
    for (let step = 0; step < CAMPAIGN_WIZARD_LAST_STEP; step += 1) {
      const errors = getStepErrors(step);
      const firstKey = Object.keys(errors)[0];
      if (firstKey) {
        return {
          errors,
          field: firstKey,
          message: errors[firstKey],
          step,
        };
      }
    }
    return null;
  };

  const focusField = (field) => {
    window.requestAnimationFrame(() => {
      fieldRefs.current[field]?.focus?.();
    });
  };

  const goToStep = (step) => {
    if (step < 0 || step > highestStep || step > CAMPAIGN_WIZARD_LAST_STEP) {
      return;
    }
    setError("");
    setActiveStep(step);
  };

  const goNext = () => {
    const errors = getStepErrors(activeStep);
    const firstField = Object.keys(errors)[0];
    if (firstField) {
      setFieldErrors(errors);
      setError(errors[firstField]);
      focusField(firstField);
      return;
    }

    const nextStep = Math.min(activeStep + 1, CAMPAIGN_WIZARD_LAST_STEP);
    setError("");
    setFieldErrors({});
    setHighestStep((current) => Math.max(current, nextStep));
    setActiveStep(nextStep);
  };

  const goBack = () => {
    setError("");
    setActiveStep((current) => Math.max(0, current - 1));
  };

  const restoreDraft = () => {
    if (!draftOffer?.form) return;
    setForm(normalizeCampaignDraftForm(draftOffer.form));
    const restoredStep = Math.min(
      Number(draftOffer.active_step || 0),
      CAMPAIGN_WIZARD_LAST_STEP
    );
    setActiveStep(restoredStep);
    setHighestStep(
      Math.max(restoredStep, Number(draftOffer.highest_step || 0))
    );
    setIsDirty(true);
    setDraftSavedAt(new Date(Number(draftOffer.saved_at)));
    setDraftOffer(null);
    setError("");
    setFieldErrors({});
  };

  const discardDraft = () => {
    window.localStorage.removeItem(CAMPAIGN_DRAFT_KEY);
    setDraftOffer(null);
  };

  const requestClose = () => {
    if (isDirty) {
      if (!draftOffer && !academyMode) {
        window.localStorage.setItem(
          CAMPAIGN_DRAFT_KEY,
          JSON.stringify({
            form,
            active_step: activeStep,
            highest_step: highestStep,
            saved_at: Date.now(),
          })
        );
      }
      setConfirmAction("close");
      return;
    }
    onClose();
  };

  const clearEmailHtml = () => {
    rememberEmailHtml(form.email_html, true);
    update("email_html", "");
    setConfirmAction("");
  };

  const sendDraftTest = async () => {
    const email =
      form.delivery_channel !== "telegram" ? testEmail.trim() : "";
    const telegramChatId =
      form.delivery_channel !== "email" ? testTelegramChatId.trim() : "";
    if (!email && !telegramChatId) {
      setTestResult({
        tone: "error",
        text: t("marketing_test_destination_required"),
      });
      return;
    }
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setTestResult({
        tone: "error",
        text: t("marketing_test_email_invalid"),
      });
      return;
    }

    setTestSending(true);
    setTestResult({ tone: "", text: "" });
    try {
      await api.post("/marketing/preview/test-send", {
        title: form.title || t("marketing_new_campaign"),
        description: form.description || null,
        email: email || null,
        telegram_chat_id: telegramChatId || null,
        email_subject: form.email_subject || form.title || null,
        email_html:
          applyEmailPreheader(form.email_html, form.email_preheader) || null,
        telegram_text: form.telegram_text || null,
        coupon_discount_type: form.coupon_discount_type || null,
        coupon_discount_value: form.coupon_discount_value || null,
        coupon_valid_days: Number(form.birthday_coupon_valid_days || 7),
      });
      setTestResult({
        tone: "success",
        text: t("marketing_test_sent_success"),
      });
    } catch (requestError) {
      setTestResult({
        tone: "error",
        text: getApiErrorText(
          requestError,
          t("marketing_test_send_failed")
        ),
      });
    } finally {
      setTestSending(false);
    }
  };

  const reviewWarnings = useMemo(() => {
    const warnings = [];
    const usesEmail = form.delivery_channel !== "telegram";
    const usesTelegram = form.delivery_channel !== "email";
    const unknownVariables = getUnknownMarketingVariables(form);

    if (usesEmail && !String(form.email_subject || "").trim()) {
      warnings.push(t("marketing_warning_email_subject_empty"));
    }
    if (usesEmail && !String(form.email_preheader || "").trim()) {
      warnings.push(t("marketing_warning_preheader_empty"));
    }
    if (
      String(form.email_html || "").includes("{{coupon_code}}") &&
      !form.generate_coupons
    ) {
      warnings.push(t("marketing_warning_coupon_variable_disabled"));
    }
    if (unknownVariables.length) {
      warnings.push(
        t("marketing_warning_unknown_variables", {
          variables: unknownVariables.join(", "),
        })
      );
    }
    if (
      usesEmail &&
      audienceReadiness &&
      Number(audienceReadiness.email_missing) > 0
    ) {
      warnings.push(
        t("marketing_warning_email_missing_count", {
          count: Number(audienceReadiness.email_missing),
        })
      );
    }
    if (
      usesTelegram &&
      audienceReadiness &&
      Number(audienceReadiness.telegram_missing) > 0
    ) {
      warnings.push(
        t("marketing_warning_telegram_missing_count", {
          count: Number(audienceReadiness.telegram_missing),
        })
      );
    }
    if (
      isBirthday &&
      audienceReadiness &&
      Number(audienceReadiness.target_contacts) === 0
    ) {
      warnings.push(t("marketing_warning_no_birthday_contacts"));
    }
    if (!isBirthday && form.ends_at) {
      const startValue =
        form.starts_at ||
        (form.trigger_type === "scheduled"
          ? form.scheduled_at
          : dateRules.effectiveStartAt);
      const duration =
        new Date(form.ends_at).getTime() - new Date(startValue).getTime();
      if (Number.isFinite(duration) && duration < 2 * 24 * 60 * 60 * 1000) {
        warnings.push(t("marketing_warning_short_validity"));
      }
    }
    return warnings;
  }, [audienceReadiness, dateRules.effectiveStartAt, form, isBirthday, t]);

  const submit = async () => {
    const validation = validateAll();
    if (validation) {
      setError(validation.message);
      setFieldErrors(validation.errors);
      setHighestStep((current) => Math.max(current, validation.step));
      setActiveStep(validation.step);
      focusField(validation.field);
      return;
    }

    setSaving(true);
    setError("");

    try {
      await marketingApi.createCampaign(buildCampaignPayload(form));
      if (!academyMode) {
        window.localStorage.removeItem(CAMPAIGN_DRAFT_KEY);
      }
      setIsDirty(false);
      await onCreated();
      onClose();
    } catch (e) {
      const detail = e?.response?.data?.detail;
      if (detail === "An active global birthday campaign already exists") {
        setError(t("marketing_global_birthday_exists"));
      } else if (
        detail === "A personal birthday campaign requires exactly one contact"
      ) {
        setError(t("marketing_personal_birthday_contact_required"));
      } else if (
        detail === "The selected contact does not have a birth date"
      ) {
        setError(t("marketing_selected_contact_birthday_missing"));
      } else {
        setError(getApiErrorText(e, t("marketing_campaign_create_failed")));
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
    <Drawer
      title={t("marketing_new_campaign")}
      subtitle={t("marketing_campaign_drawer_subtitle")}
      wide
      onClose={requestClose}
      footer={
        <div
          data-academy="marketing-wizard-footer"
          className="vcrm-wizardFooter"
        >
          <div className="vcrm-wizardFooterMeta">
            <strong>
              {t("marketing_wizard_step_counter", {
                current: activeStep + 1,
                total: CAMPAIGN_WIZARD_STEPS.length,
              })}
            </strong>
            <span>{t(CAMPAIGN_WIZARD_STEPS[activeStep].title)}</span>
          </div>
          <button
            data-academy="marketing-wizard-cancel"
            className="vcrm-btn secondary"
            type="button"
            onClick={requestClose}
          >
            {t("cancel")}
          </button>
          {activeStep > 0 && (
            <button
              data-academy="marketing-wizard-back"
              className="vcrm-btn secondary"
              type="button"
              onClick={goBack}
              disabled={saving}
            >
              {t("back")}
            </button>
          )}
          {activeStep < CAMPAIGN_WIZARD_LAST_STEP ? (
            <button
              data-academy="marketing-wizard-continue"
              className="vcrm-btn primary"
              type="button"
              onClick={goNext}
              disabled={saving || (activeStep === 0 && globalBirthdayConflict)}
            >
              {t("marketing_wizard_continue")}
            </button>
          ) : (
            <button
              data-academy="marketing-wizard-create"
              className="vcrm-btn primary"
              type="button"
              onClick={submit}
              disabled={saving || globalBirthdayConflict}
            >
              {saving ? t("saving") : t("marketing_create_campaign")}
            </button>
          )}
        </div>
      }
    >
      {draftOffer && (
        <div className="vcrm-draftRestore">
          <div>
            <strong>{t("marketing_draft_found_title")}</strong>
            <span>
              {t("marketing_draft_found_hint", {
                date: formatDate(new Date(Number(draftOffer.saved_at))),
              })}
            </span>
          </div>
          <div>
            <button
              className="vcrm-btn secondary small"
              type="button"
              onClick={discardDraft}
            >
              {t("marketing_draft_discard")}
            </button>
            <button
              className="vcrm-btn primary small"
              type="button"
              onClick={restoreDraft}
            >
              {t("marketing_draft_restore")}
            </button>
          </div>
        </div>
      )}

      {isDirty && (
        <div
          data-academy="marketing-draft-status"
          className="vcrm-draftStatus"
          role="status"
        >
          <span className={draftSavedAt ? "isSaved" : ""} />
          {draftSavedAt
            ? t("marketing_draft_saved", {
                time: draftSavedAt.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                }),
              })
            : t("marketing_draft_saving")}
        </div>
      )}

      <div
        ref={wizardTopRef}
        data-academy="marketing-wizard-navigation"
        className="vcrm-wizardTop"
      >
        <div className="vcrm-wizardProgress">
          <div
            className="vcrm-wizardProgressBar"
            style={{
              width: `${((activeStep + 1) / CAMPAIGN_WIZARD_STEPS.length) * 100}%`,
            }}
          />
        </div>

        <nav
          className="vcrm-wizardSteps"
          aria-label={t("marketing_wizard_navigation")}
        >
          {CAMPAIGN_WIZARD_STEPS.map((step, index) => {
            const isActive = index === activeStep;
            const isComplete =
              index !== activeStep &&
              index <= highestStep &&
              Object.keys(getStepErrors(index)).length === 0;
            const isAvailable = index <= highestStep;
            return (
              <button
                key={step.title}
                data-academy={`marketing-wizard-step-${index + 1}`}
                type="button"
                className={`${isActive ? "isActive" : ""} ${
                  isComplete ? "isComplete" : ""
                }`}
                onClick={() => goToStep(index)}
                disabled={!isAvailable}
                aria-current={isActive ? "step" : undefined}
              >
                <span>{isComplete && !isActive ? "✓" : index + 1}</span>
                <div>
                  <strong>{t(step.title)}</strong>
                  <small>{t(step.hint)}</small>
                </div>
              </button>
            );
          })}
        </nav>
      </div>

      {error && (
        <div className="vcrm-alert error vcrm-wizardAlert">{error}</div>
      )}

      <div className="vcrm-composeLayout vcrm-wizardLayout">
        <div className="vcrm-composeMain">
          {activeStep === 0 && (
          <section
            data-academy="marketing-wizard-basics"
            className="vcrm-formSection"
          >
            <div className="vcrm-sectionTitle">
              <span>01</span>
              <div>
                <h3>{t("marketing_main")}</h3>
                <p>{t("marketing_main_hint")}</p>
              </div>
            </div>

            <div className="vcrm-formGrid">
              <Field
                label={t("marketing_campaign_name")}
                full
                error={fieldErrors.title}
              >
                <input
                  data-academy="marketing-campaign-title"
                  ref={(node) => {
                    fieldRefs.current.title = node;
                  }}
                  className="vcrm-input"
                  value={form.title}
                  onChange={(event) => update("title", event.target.value)}
                  placeholder={t("marketing_campaign_name_placeholder")}
                />
              </Field>

              <Field
                label={t("contact_type")}
                error={fieldErrors.campaign_type}
              >
                <select
                  data-academy="marketing-campaign-type"
                  ref={(node) => {
                    fieldRefs.current.campaign_type = node;
                  }}
                  className="vcrm-input"
                  value={form.campaign_type}
                  onChange={(event) => update("campaign_type", event.target.value)}
                >
                  <option value="global">{t("marketing_global_campaign")}</option>
                  <option value="personal">{t("marketing_personal_campaign")}</option>
                </select>
              </Field>

              <Field label={t("crm_activities_channel")}>
                <select
                  data-academy="marketing-campaign-channel"
                  className="vcrm-input"
                  value={form.delivery_channel}
                  onChange={(event) => update("delivery_channel", event.target.value)}
                >
                  <option value="both">{t("marketing_channel_both")}</option>
                  <option value="email">{t("marketing_channel_email")}</option>
                  <option value="telegram">{t("marketing_channel_telegram")}</option>
                </select>
              </Field>

              <Field label={t("marketing_launch")}>
                <select
                  data-academy="marketing-campaign-trigger"
                  className="vcrm-input"
                  value={form.trigger_type}
                  onChange={(event) => update("trigger_type", event.target.value)}
                >
                  <option value="immediate">{t("marketing_launch_immediately")}</option>
                  <option value="scheduled">{t("marketing_launch_datetime")}</option>
                  <option value="birthday">{t("marketing_birthday")}</option>
                </select>
              </Field>

              {isBirthday ? (
                <>
                  <div
                    data-academy="marketing-birthday-rule"
                    className={`vcrm-infoNotice full ${
                      globalBirthdayConflict ? "isDanger" : "isBirthday"
                    }`}
                  >
                    <strong>
                      {globalBirthdayConflict
                        ? t("marketing_global_birthday_exists_title")
                        : isGlobalBirthday
                        ? t("marketing_global_birthday_automatic_title")
                        : t("marketing_personal_birthday_automatic_title")}
                    </strong>
                    <span>
                      {globalBirthdayConflict
                        ? t("marketing_global_birthday_exists")
                        : isGlobalBirthday
                        ? t("marketing_global_birthday_automatic_hint")
                        : t("marketing_personal_birthday_automatic_hint")}
                    </span>
                  </div>

                  <Field label={t("marketing_delivery_date")}>
                    <input
                      data-academy="marketing-birthday-delivery-date"
                      className="vcrm-input"
                      value={t("marketing_birthday_contact_day_midnight")}
                      disabled
                      readOnly
                    />
                    <small className="vcrm-fieldHint">
                      {t("marketing_birthday_delivery_date_hint")}
                    </small>
                  </Field>

                  <Field label={t("marketing_start_date")}>
                    <input
                      data-academy="marketing-birthday-start-date"
                      className="vcrm-input"
                      value={t("marketing_birthday_contact_day")}
                      disabled
                      readOnly
                    />
                    <small className="vcrm-fieldHint">
                      {t("marketing_birthday_start_date_hint")}
                    </small>
                  </Field>

                  <Field
                    label={t("marketing_end_date")}
                    error={fieldErrors.birthday_coupon_valid_days}
                  >
                    <select
                      data-academy="marketing-birthday-validity"
                      ref={(node) => {
                        fieldRefs.current.birthday_coupon_valid_days = node;
                      }}
                      className="vcrm-input"
                      value={
                        [7, 14, 21, 30].includes(
                          Number(form.birthday_coupon_valid_days)
                        )
                          ? String(form.birthday_coupon_valid_days)
                          : "custom"
                      }
                      onChange={(event) => {
                        const value = event.target.value;
                        update(
                          "birthday_coupon_valid_days",
                          value === "custom"
                            ? 10
                            : Number(value)
                        );
                      }}
                    >
                      <option value="7">{t("seven_days")}</option>
                      <option value="14">{t("marketing_days_14")}</option>
                      <option value="21">{t("marketing_days_21")}</option>
                      <option value="30">{t("marketing_days_30")}</option>
                      <option value="custom">
                        {t("marketing_custom_value")}
                      </option>
                    </select>
                    <small className="vcrm-fieldHint">
                      {t("marketing_birthday_offer_validity_hint")}
                    </small>
                  </Field>

                  {![7, 14, 21, 30].includes(
                    Number(form.birthday_coupon_valid_days)
                  ) && (
                    <Field
                      label={t("marketing_custom_days")}
                      error={fieldErrors.birthday_coupon_valid_days}
                    >
                      <input
                        data-academy="marketing-birthday-validity-custom"
                        ref={(node) => {
                          fieldRefs.current.birthday_coupon_valid_days = node;
                        }}
                        className="vcrm-input"
                        type="number"
                        min="1"
                        max="365"
                        step="1"
                        value={form.birthday_coupon_valid_days}
                        onChange={(event) =>
                          update(
                            "birthday_coupon_valid_days",
                            event.target.value
                          )
                        }
                      />
                    </Field>
                  )}
                </>
              ) : (
                <>
                  {form.trigger_type === "scheduled" && (
                    <Field
                      label={t("marketing_delivery_date")}
                      error={fieldErrors.scheduled_at}
                    >
                      <input
                        data-academy="marketing-delivery-date"
                        ref={(node) => {
                          fieldRefs.current.scheduled_at = node;
                        }}
                        className="vcrm-input"
                        type="datetime-local"
                        min={dateRules.now}
                        value={form.scheduled_at}
                        onChange={(event) =>
                          update("scheduled_at", event.target.value)
                        }
                      />
                      <small className="vcrm-fieldHint">
                        {t("marketing_past_date_forbidden")}
                      </small>
                    </Field>
                  )}

                  <Field
                    label={t("marketing_start_date")}
                    error={fieldErrors.starts_at}
                  >
                    <input
                      data-academy="marketing-start-date"
                      ref={(node) => {
                        fieldRefs.current.starts_at = node;
                      }}
                      className="vcrm-input"
                      type="datetime-local"
                      min={dateRules.startMin}
                      value={
                        form.trigger_type === "immediate"
                          ? dateRules.effectiveStartAt
                          : form.starts_at
                      }
                      disabled={!dateRules.canPickStart}
                      onChange={(event) =>
                        update("starts_at", event.target.value)
                      }
                    />
                    <small className="vcrm-fieldHint">
                      {form.trigger_type === "immediate"
                        ? t("marketing_immediate_start_hint")
                        : dateRules.canPickStart
                        ? t("marketing_not_before_delivery")
                        : t("marketing_select_delivery_first")}
                    </small>
                  </Field>

                  <Field
                    label={t("marketing_end_date")}
                    error={fieldErrors.ends_at}
                  >
                    <input
                      data-academy="marketing-end-date"
                      ref={(node) => {
                        fieldRefs.current.ends_at = node;
                      }}
                      className="vcrm-input"
                      type="datetime-local"
                      min={dateRules.endMin}
                      value={form.ends_at}
                      disabled={!dateRules.canPickEnd}
                      onChange={(event) =>
                        update("ends_at", event.target.value)
                      }
                    />
                    <small className="vcrm-fieldHint">
                      {dateRules.canPickEnd
                        ? t("marketing_minimum_one_day")
                        : t("marketing_select_start_first")}
                    </small>
                  </Field>
                </>
              )}

              <Field label={t("marketing_short_description")} full>
                <textarea
                  data-academy="marketing-short-description"
                  className="vcrm-textarea short"
                  value={form.description}
                  onChange={(event) => update("description", event.target.value)}
                  placeholder={t("marketing_description_placeholder")}
                />
              </Field>
            </div>
          </section>
          )}

          {activeStep === 1 && (
          <section
            data-academy="marketing-wizard-message"
            className="vcrm-formSection"
          >
            <div className="vcrm-sectionTitle">
              <span>02</span>
              <div>
                <h3>{t("message")}</h3>
                <p>{t("marketing_coupon_variable_hint")} {"{{coupon_code}}"}</p>
              </div>
            </div>

            {isGlobalBirthday && (
              <div className="vcrm-infoNotice isBirthday">
                <strong>{t("marketing_standard_birthday_message_title")}</strong>
                <span>{t("marketing_standard_birthday_message_hint")}</span>
              </div>
            )}

            <div className="vcrm-formGrid one">
              {form.delivery_channel !== "telegram" && (
                <>
                  <Field label={t("marketing_email_subject")}>
                    <div className="vcrm-editableField">
                      <input
                        data-academy="marketing-email-subject"
                        className="vcrm-input"
                        value={form.email_subject}
                        maxLength={255}
                        onChange={(event) => update("email_subject", event.target.value)}
                        placeholder={t("marketing_email_subject_placeholder")}
                      />
                      <small>
                        {t("marketing_subject_character_count", {
                          count: (form.email_subject || "").length,
                        })}
                      </small>
                    </div>
                  </Field>

                  <Field label={t("marketing_email_preheader")}>
                    <div className="vcrm-editableField">
                      <input
                        data-academy="marketing-email-preheader"
                        className="vcrm-input"
                        value={form.email_preheader || ""}
                        maxLength={180}
                        onChange={(event) =>
                          update("email_preheader", event.target.value)
                        }
                        placeholder={t(
                          "marketing_email_preheader_placeholder"
                        )}
                      />
                      <small>
                        {t("marketing_preheader_character_count", {
                          count: (form.email_preheader || "").length,
                        })}
                      </small>
                    </div>
                    <small className="vcrm-fieldHint">
                      {t("marketing_email_preheader_hint")}
                    </small>
                  </Field>

                  <Field
                    label={t("marketing_email_html")}
                    error={fieldErrors.email_html}
                  >
                    <div
                      data-academy="marketing-email-editor"
                      className="vcrm-emailEditorBox"
                    >
                      <div className="vcrm-emailEditorTop">
                        <div className="vcrm-emailEditorIntro">
                          <div className="vcrm-emailEditorTitleRow">
                            <strong>
                              {isBirthday
                                ? t("marketing_birthday_template_editor_title")
                                : t("marketing_clean_email_template")}
                            </strong>
                            <span className="vcrm-editableBadge">
                              {t("marketing_email_template_editable")}
                            </span>
                          </div>
                          <span className="vcrm-emailEditorDescription">
                            {isBirthday
                              ? t("marketing_birthday_template_editor_hint")
                              : (
                                <>
                                  {t("marketing_logo_template_hint")} <code>{"{{company_logo_img}}"}</code>{t("marketing_logo_settings_suffix")}
                                </>
                              )}
                          </span>
                        </div>
                        <div
                          data-academy="marketing-email-editor-actions"
                          className="vcrm-emailEditorActions"
                        >
                          <button
                            className="vcrm-btn secondary small"
                            type="button"
                            onClick={undoEmailHtml}
                            disabled={!emailHistoryRef.current.length}
                          >
                            <svg aria-hidden="true" viewBox="0 0 24 24">
                              <path d="M9 7H5v-4M5.5 7.5A8 8 0 1 1 4 14" />
                            </svg>
                            {t("marketing_undo_html")}
                          </button>
                          <button
                            className="vcrm-btn secondary small"
                            type="button"
                            onClick={applyProfessionalEmailTemplate}
                          >
                            <svg aria-hidden="true" viewBox="0 0 24 24">
                              <path d="M4 5.5h16v13H4zM8 9h8M8 13h5" />
                            </svg>
                            {isBirthday
                              ? t("marketing_apply_birthday_template")
                              : t("marketing_insert_template")}
                          </button>
                          <button
                            className="vcrm-btn ghostDanger small"
                            type="button"
                            onClick={() => setConfirmAction("clear-html")}
                          >
                            <svg aria-hidden="true" viewBox="0 0 24 24">
                              <path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5" />
                            </svg>
                            {t("marketing_clear_html")}
                          </button>
                        </div>
                      </div>

                      <div
                        data-academy="marketing-email-variables"
                        className="vcrm-variablePanel"
                      >
                        {CRM_VARIABLE_GROUPS.map((group) => (
                          <div className="vcrm-variableGroup" key={group.title}>
                            <strong>{t(group.title)}</strong>
                            <div>
                              {group.items.map(([token, label]) => (
                                <button
                                  key={token}
                                  type="button"
                                  onClick={() => insertEmailVariable(token)}
                                  title={token}
                                >
                                  {t(label)}
                                </button>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>

                      <textarea
                        data-academy="marketing-email-html-code"
                        ref={(node) => {
                          emailEditorRef.current = node;
                          fieldRefs.current.email_html = node;
                        }}
                        className="vcrm-textarea html"
                        value={form.email_html}
                        onChange={(event) => update("email_html", event.target.value)}
                        placeholder={t("marketing_email_html_placeholder")}
                        spellCheck={false}
                      />

                      {getUnknownMarketingVariables(form).length > 0 && (
                        <div className="vcrm-templateWarning">
                          <strong>
                            {t("marketing_unknown_variables_title")}
                          </strong>
                          <span>
                            {t("marketing_unknown_variables_hint", {
                              variables:
                                getUnknownMarketingVariables(form).join(", "),
                            })}
                          </span>
                        </div>
                      )}
                    </div>
                  </Field>
                </>
              )}

              {form.delivery_channel !== "email" && (
                <Field
                  label={t("marketing_telegram_message")}
                  error={fieldErrors.telegram_text}
                >
                  <textarea
                    data-academy="marketing-telegram-text"
                    ref={(node) => {
                      fieldRefs.current.telegram_text = node;
                    }}
                    className="vcrm-textarea short"
                    value={form.telegram_text}
                    onChange={(event) => update("telegram_text", event.target.value)}
                  />
                </Field>
              )}
            </div>
          </section>
          )}

          {activeStep === 2 && (
          <section
            data-academy="marketing-wizard-recipients"
            className="vcrm-formSection"
          >
            <div className="vcrm-sectionTitle">
              <span>03</span>
              <div>
                <h3>{t("marketing_recipients_heading")}</h3>
                <p>{t("marketing_recipients_contacts_hint")}</p>
              </div>
            </div>

            <div
              data-academy="marketing-audience-readiness"
              ref={(node) => {
                fieldRefs.current.contact_ids = node;
              }}
              className={`vcrm-audienceReadiness ${
                fieldErrors.contact_ids ? "hasError" : ""
              }`}
              tabIndex="-1"
            >
              <div className="vcrm-audienceReadinessHead">
                <div>
                  <strong>{t("marketing_audience_readiness_title")}</strong>
                  <span>
                    {audienceReadiness
                      ? t(
                          `marketing_audience_scope_${audienceReadiness.scope}`
                        )
                      : t("marketing_audience_readiness_hint")}
                  </span>
                </div>
                {audienceLoading && (
                  <span className="vcrm-inlineLoader">{t("loading")}</span>
                )}
              </div>

              {audienceError ? (
                <div className="vcrm-fieldError">{audienceError}</div>
              ) : audienceReadiness ? (
                <div className="vcrm-audienceMetrics">
                  <div>
                    <span>{t("marketing_audience_target")}</span>
                    <strong>{audienceReadiness.target_contacts}</strong>
                  </div>
                  <div>
                    <span>Email</span>
                    <strong>{audienceReadiness.email_available}</strong>
                    <small>
                      {t("marketing_audience_missing", {
                        count: audienceReadiness.email_missing,
                      })}
                    </small>
                  </div>
                  <div>
                    <span>Telegram</span>
                    <strong>{audienceReadiness.telegram_connected}</strong>
                    <small>
                      {t("marketing_audience_missing", {
                        count: audienceReadiness.telegram_missing,
                      })}
                    </small>
                  </div>
                  <div>
                    <span>{t("marketing_audience_both")}</span>
                    <strong>{audienceReadiness.both_available}</strong>
                  </div>
                </div>
              ) : null}

              {fieldErrors.contact_ids && (
                <small className="vcrm-fieldError">
                  {fieldErrors.contact_ids}
                </small>
              )}
            </div>

            {isGlobalBirthday ? (
              <div
                data-academy="marketing-birthday-audience-note"
                className="vcrm-infoNotice isBirthday"
              >
                <strong>{t("marketing_global_birthday_audience_title")}</strong>
                <span>{t("marketing_global_birthday_audience_hint")}</span>
              </div>
            ) : isPersonalBirthday ? (
              <div className="vcrm-birthdayContactPicker">
                <input
                  className="vcrm-input"
                  value={contactQuery}
                  onChange={(event) => setContactQuery(event.target.value)}
                  placeholder={t("marketing_search_birthday_contact")}
                />

                {selectedBirthdayContact && (
                  <div className="vcrm-selectedBirthdayContact">
                    <strong>{t("marketing_selected_contact")}</strong>
                    <span>
                      {selectedBirthdayContact.full_name ||
                        selectedBirthdayContact.email ||
                        `#${selectedBirthdayContact.id}`}
                      {" · "}
                      {formatBirthDate(getContactBirthDate(selectedBirthdayContact))}
                    </span>
                  </div>
                )}

                {birthdayContactsLoading ? (
                  <div className="vcrm-empty">{t("loading")}</div>
                ) : birthdayContactsError ? (
                  <div className="vcrm-alert error">{birthdayContactsError}</div>
                ) : birthdayContacts.length ? (
                  <div className="vcrm-contactList">
                    {birthdayContacts.map((contact) => {
                      const birthDate = getContactBirthDate(contact);
                      const selected =
                        Number(contact.id) === selectedBirthdayContactId;
                      return (
                        <label
                          className={`vcrm-contactItem ${
                            selected ? "isSelected" : ""
                          } ${birthDate ? "" : "isDisabled"}`}
                          key={contact.id}
                        >
                          <input
                            type="radio"
                            name="birthday-contact"
                            checked={selected}
                            disabled={!birthDate}
                            onChange={() =>
                              update("contact_ids", [Number(contact.id)])
                            }
                          />
                          <span>
                            <strong>
                              {contact.full_name ||
                                contact.email ||
                                `#${contact.id}`}
                            </strong>
                            <small>
                              {birthDate
                                ? formatBirthDate(birthDate)
                                : t("marketing_contact_birthday_missing")}
                            </small>
                          </span>
                        </label>
                      );
                    })}
                  </div>
                ) : (
                  <div className="vcrm-empty">
                    {t("marketing_no_birthday_contacts_found")}
                  </div>
                )}
              </div>
            ) : (
              <div
                data-academy="marketing-global-audience-note"
                className="vcrm-infoNotice"
              >
                <strong>{t("marketing_saved_as_template")}</strong>
                <span>{t("marketing_send_from_contacts_hint")}</span>
              </div>
            )}
          </section>
          )}

          {activeStep === 3 && (
          <>
          <section
            data-academy="marketing-wizard-conditions"
            className="vcrm-formSection"
          >
            <div className="vcrm-sectionTitle">
              <span>A</span>
              <div>
                <h3>{t("marketing_auto_delete")}</h3>
                <p>{t("marketing_auto_delete_hint")}</p>
              </div>
            </div>

            {isGlobalBirthday ? (
              <div className="vcrm-infoNotice isBirthday">
                <strong>{t("marketing_global_birthday_no_end_title")}</strong>
                <span>{t("marketing_global_birthday_no_end_hint")}</span>
              </div>
            ) : (
              <div className="vcrm-formGrid">
                <label className="vcrm-check full">
                  <input
                    type="checkbox"
                    checked={form.auto_delete_enabled}
                    onChange={(event) =>
                      update("auto_delete_enabled", event.target.checked)
                    }
                  />
                  <span>{t("marketing_enable_auto_delete")}</span>
                </label>

                <Field
                  label={t("marketing_delete_after")}
                  error={fieldErrors.delete_after_days}
                >
                  <select
                    className="vcrm-input"
                    value={
                      [7, 14, 30, 60, 90].includes(
                        Number(form.delete_after_days)
                      )
                        ? String(form.delete_after_days)
                        : "custom"
                    }
                    disabled={!form.auto_delete_enabled}
                    onChange={(event) => {
                      const value = event.target.value;
                      update(
                        "delete_after_days",
                        value === "custom"
                          ? form.delete_after_days || 30
                          : Number(value)
                      );
                    }}
                  >
                    <option value="7">{t("seven_days")}</option>
                    <option value="14">{t("marketing_days_14")}</option>
                    <option value="30">{t("marketing_days_30")}</option>
                    <option value="60">{t("marketing_days_60")}</option>
                    <option value="90">{t("marketing_days_90")}</option>
                    <option value="custom">{t("marketing_custom_value")}</option>
                  </select>
                </Field>

                <Field
                  label={t("marketing_custom_days")}
                  error={fieldErrors.delete_after_days}
                >
                  <input
                    ref={(node) => {
                      fieldRefs.current.delete_after_days = node;
                    }}
                    className="vcrm-input"
                    type="number"
                    min="1"
                    max="365"
                    value={form.delete_after_days}
                    disabled={!form.auto_delete_enabled}
                    onChange={(event) =>
                      update("delete_after_days", event.target.value)
                    }
                  />
                </Field>
              </div>
            )}
          </section>

          <section
            data-academy="marketing-coupon-settings"
            className="vcrm-formSection"
          >
            <div className="vcrm-sectionTitle">
              <span>B</span>
              <div>
                <h3>{t("marketing_coupon")}</h3>
                <p>{t("marketing_coupon_settings_hint")}</p>
              </div>
            </div>

            <div className="vcrm-formGrid">
              <label className="vcrm-check full">
                <input
                  type="checkbox"
                  checked={form.generate_coupons}
                  disabled={isGlobalBirthday}
                  onChange={(event) => update("generate_coupons", event.target.checked)}
                />
                <span>{t("marketing_generate_coupons")}</span>
              </label>

              {form.generate_coupons && (
                <>
                  <Field label={t("marketing_coupon_type")}>
                    <select
                      className="vcrm-input"
                      value={form.coupon_type}
                      disabled={isBirthday}
                      onChange={(event) => update("coupon_type", event.target.value)}
                    >
                      <option value="personal">{t("account_email_mode_personal")}</option>
                      <option value="public">{t("marketing_coupon_public")}</option>
                      <option value="birthday">{t("preset_contact_field_birthday")}</option>
                      <option value="referral">{t("source_preset_referral")}</option>
                      <option value="gift">{t("marketing_gift")}</option>
                    </select>
                  </Field>

                  <Field label={t("marketing_discount_type")}>
                    <select
                      className="vcrm-input"
                      value={form.coupon_discount_type}
                      onChange={(event) => update("coupon_discount_type", event.target.value)}
                    >
                      <option value="percent">{t("percentage")}</option>
                      <option value="fixed">{t("marketing_fixed_amount")}</option>
                      <option value="gift">{t("marketing_gift")}</option>
                    </select>
                  </Field>

                  <Field
                    label={t("dashboard_value")}
                    error={fieldErrors.coupon_discount_value}
                  >
                    <input
                      ref={(node) => {
                        fieldRefs.current.coupon_discount_value = node;
                      }}
                      className="vcrm-input"
                      type="number"
                      value={form.coupon_discount_value}
                      onChange={(event) => update("coupon_discount_value", event.target.value)}
                    />
                  </Field>

                  <Field
                    label={t("marketing_email_daily_limit")}
                    error={fieldErrors.daily_email_limit}
                  >
                    <input
                      ref={(node) => {
                        fieldRefs.current.daily_email_limit = node;
                      }}
                      className="vcrm-input"
                      type="number"
                      value={form.daily_email_limit}
                      onChange={(event) => update("daily_email_limit", event.target.value)}
                    />
                  </Field>
                </>
              )}

              {isBirthday ? (
                <div
                  data-academy="marketing-birthday-activation"
                  className="vcrm-infoNotice full isBirthday"
                >
                  <strong>{t("marketing_birthday_activation_title")}</strong>
                  <span>{t("marketing_birthday_activation_hint")}</span>
                </div>
              ) : (
                <label className="vcrm-check full">
                  <input
                    type="checkbox"
                    checked={form.auto_start}
                    onChange={(event) =>
                      update("auto_start", event.target.checked)
                    }
                  />
                  <span>{t("marketing_queue_immediately")}</span>
                </label>
              )}
            </div>
          </section>
          </>
          )}

          {activeStep === 4 && (
            <section
              data-academy="marketing-wizard-review"
              className="vcrm-formSection vcrm-reviewSection"
            >
              <div className="vcrm-sectionTitle">
                <span>05</span>
                <div>
                  <h3>{t("marketing_wizard_review_title")}</h3>
                  <p>{t("marketing_wizard_review_description")}</p>
                </div>
              </div>

              <div
                data-academy="marketing-review-edit-actions"
                className="vcrm-reviewGrid"
              >
                <article className="vcrm-reviewCard">
                  <header>
                    <div>
                      <span>01</span>
                      <h4>{t("marketing_wizard_step_main")}</h4>
                    </div>
                    <button type="button" onClick={() => goToStep(0)}>
                      {t("edit")}
                    </button>
                  </header>
                  <dl>
                    <div>
                      <dt>{t("marketing_campaign_name")}</dt>
                      <dd>{form.title || "—"}</dd>
                    </div>
                    <div>
                      <dt>{t("contact_type")}</dt>
                      <dd>
                        {form.campaign_type === "global"
                          ? t("marketing_global_campaign")
                          : t("marketing_personal_campaign")}
                      </dd>
                    </div>
                    <div>
                      <dt>{t("crm_activities_channel")}</dt>
                      <dd>{t(CHANNEL_LABELS[form.delivery_channel])}</dd>
                    </div>
                    <div>
                      <dt>{t("marketing_launch")}</dt>
                      <dd>{t(TRIGGER_LABELS[form.trigger_type])}</dd>
                    </div>
                  </dl>
                </article>

                <article className="vcrm-reviewCard">
                  <header>
                    <div>
                      <span>02</span>
                      <h4>{t("marketing_wizard_step_message")}</h4>
                    </div>
                    <button type="button" onClick={() => goToStep(1)}>
                      {t("edit")}
                    </button>
                  </header>
                  <dl>
                    {form.delivery_channel !== "telegram" && (
                      <div>
                        <dt>{t("marketing_email_subject")}</dt>
                        <dd>{form.email_subject || "—"}</dd>
                      </div>
                    )}
                    <div>
                      <dt>{t("marketing_email_html")}</dt>
                      <dd>
                        {form.delivery_channel === "telegram"
                          ? t("marketing_channel_not_selected")
                          : t("marketing_wizard_content_ready")}
                      </dd>
                    </div>
                    <div>
                      <dt>{t("marketing_telegram_message")}</dt>
                      <dd>
                        {form.delivery_channel === "email"
                          ? t("marketing_channel_not_selected")
                          : t("marketing_wizard_content_ready")}
                      </dd>
                    </div>
                  </dl>
                </article>

                <article className="vcrm-reviewCard">
                  <header>
                    <div>
                      <span>03</span>
                      <h4>{t("marketing_wizard_step_recipients")}</h4>
                    </div>
                    <button type="button" onClick={() => goToStep(2)}>
                      {t("edit")}
                    </button>
                  </header>
                  <dl>
                    <div>
                      <dt>{t("marketing_recipients_heading")}</dt>
                      <dd>
                        {isGlobalBirthday
                          ? t("marketing_all_birthday_contacts")
                          : isPersonalBirthday && selectedBirthdayContact
                          ? selectedBirthdayContact.full_name ||
                            selectedBirthdayContact.email ||
                            `#${selectedBirthdayContact.id}`
                          : t("marketing_wizard_recipients_from_contacts")}
                      </dd>
                    </div>
                  </dl>
                </article>

                <article className="vcrm-reviewCard">
                  <header>
                    <div>
                      <span>04</span>
                      <h4>{t("marketing_wizard_step_conditions")}</h4>
                    </div>
                    <button type="button" onClick={() => goToStep(3)}>
                      {t("edit")}
                    </button>
                  </header>
                  <dl>
                    <div>
                      <dt>{t("marketing_coupon")}</dt>
                      <dd>
                        {form.generate_coupons
                          ? `${form.coupon_discount_value}${
                              form.coupon_discount_type === "percent" ? "%" : ""
                            }`
                          : t("no")}
                      </dd>
                    </div>
                    {isBirthday && form.generate_coupons && (
                      <div>
                        <dt>{t("marketing_birthday_offer_validity")}</dt>
                        <dd>
                          {t("marketing_birthday_offer_validity_days", {
                            days: Number(form.birthday_coupon_valid_days || 7),
                          })}
                        </dd>
                      </div>
                    )}
                    <div>
                      <dt>{t("marketing_auto_delete")}</dt>
                      <dd>
                        {isGlobalBirthday
                          ? t("marketing_birthday_no_end")
                          : form.auto_delete_enabled
                          ? t("marketing_birthday_offer_validity_days", {
                              days: Number(form.delete_after_days || 30),
                            })
                          : t("no")}
                      </dd>
                    </div>
                  </dl>
                </article>
              </div>

              {reviewWarnings.length > 0 && (
                <div className="vcrm-reviewWarnings">
                  <div>
                    <strong>{t("marketing_review_warnings_title")}</strong>
                    <span>
                      {t("marketing_review_warnings_count", {
                        count: reviewWarnings.length,
                      })}
                    </span>
                  </div>
                  <ul>
                    {reviewWarnings.map((warning) => (
                      <li key={warning}>{warning}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div
                className={`vcrm-reviewReady ${
                  reviewWarnings.length ? "hasWarnings" : ""
                }`}
              >
                <strong>
                  {reviewWarnings.length
                    ? t("marketing_wizard_ready_with_warnings_title")
                    : t("marketing_wizard_ready_title")}
                </strong>
                <span>
                  {reviewWarnings.length
                    ? t("marketing_wizard_ready_with_warnings_hint")
                    : t("marketing_wizard_ready_hint")}
                </span>
              </div>
            </section>
          )}
        </div>

        <aside
          data-academy="marketing-fixed-preview"
          className="vcrm-composeSide"
        >
          <CampaignPreview
            form={form}
            onEmailHtmlChange={(value) => update("email_html", value)}
          />

          <div
            data-academy="marketing-test-delivery"
            className="vcrm-sideTestCard"
          >
            <button
              data-academy="marketing-test-delivery-toggle"
              className="vcrm-sideCardToggle"
              type="button"
              onClick={() => setTestPanelOpen((current) => !current)}
              aria-expanded={testPanelOpen}
            >
              <div>
                <strong>{t("marketing_test_delivery")}</strong>
                <span>{t("marketing_test_before_create_hint")}</span>
              </div>
              <span>{testPanelOpen ? "−" : "+"}</span>
            </button>

            {testPanelOpen && (
              <div
                data-academy="marketing-test-delivery-body"
                className="vcrm-sideTestBody"
              >
                {form.delivery_channel !== "telegram" && (
                  <input
                    className="vcrm-input"
                    type="email"
                    value={testEmail}
                    onChange={(event) => {
                      setTestEmail(event.target.value);
                      setTestResult({ tone: "", text: "" });
                    }}
                    placeholder={t("marketing_test_email_placeholder")}
                  />
                )}
                {form.delivery_channel !== "email" && (
                  <input
                    className="vcrm-input"
                    value={testTelegramChatId}
                    onChange={(event) => {
                      setTestTelegramChatId(event.target.value);
                      setTestResult({ tone: "", text: "" });
                    }}
                    placeholder={t("marketing_test_telegram_placeholder")}
                  />
                )}
                <button
                  className="vcrm-btn secondary"
                  type="button"
                  onClick={sendDraftTest}
                  disabled={testSending}
                >
                  {testSending ? t("sending") : t("marketing_send_test")}
                </button>
                {testResult.text && (
                  <div className={`vcrm-testResult ${testResult.tone}`}>
                    {testResult.text}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className={`vcrm-summaryCard ${summaryOpen ? "isOpen" : ""}`}>
            <button
              className="vcrm-sideCardToggle"
              type="button"
              onClick={() => setSummaryOpen((current) => !current)}
              aria-expanded={summaryOpen}
            >
              <div>
                <strong>{t("external_api_scope_summary")}</strong>
                <span>{t("marketing_summary_collapse_hint")}</span>
              </div>
              <span>{summaryOpen ? "−" : "+"}</span>
            </button>
            {summaryOpen && <dl>
              <div>
                <dt>{t("crm_activities_channel")}</dt>
                <dd>{t(CHANNEL_LABELS[form.delivery_channel])}</dd>
              </div>
              <div>
                <dt>{t("marketing_launch")}</dt>
                <dd>{t(TRIGGER_LABELS[form.trigger_type])}</dd>
              </div>
              <div>
                <dt>{t("marketing_clients")}</dt>
                <dd>
                  {audienceLoading
                    ? "…"
                    : audienceReadiness
                    ? audienceReadiness.target_contacts
                    : isGlobalBirthday
                    ? t("marketing_all_birthday_contacts")
                    : (form.contact_ids || []).length}
                </dd>
              </div>
              <div>
                <dt>{t("academy_page_title_081")}</dt>
                <dd>{form.generate_coupons ? `${form.coupon_discount_value}${form.coupon_discount_type === "percent" ? "%" : ""}` : t("no")}</dd>
              </div>
              {isBirthday && form.generate_coupons && (
                <div>
                  <dt>{t("marketing_birthday_offer_validity")}</dt>
                  <dd>
                    {t("marketing_birthday_offer_validity_days", {
                      days: Number(form.birthday_coupon_valid_days || 7),
                    })}
                  </dd>
                </div>
              )}
            </dl>}
          </div>
        </aside>
      </div>
    </Drawer>
      <ConfirmDialog
        open={confirmAction === "close"}
        title={t("marketing_close_unsaved_title")}
        text={t("marketing_close_unsaved_hint")}
        confirmLabel={t("marketing_close_anyway")}
        cancelLabel={t("marketing_continue_editing")}
        onCancel={() => setConfirmAction("")}
        onConfirm={onClose}
      />
      <ConfirmDialog
        open={confirmAction === "clear-html"}
        title={t("marketing_clear_html_confirm_title")}
        text={t("marketing_clear_html_confirm_hint")}
        confirmLabel={t("marketing_clear_html")}
        cancelLabel={t("cancel")}
        danger
        onCancel={() => setConfirmAction("")}
        onConfirm={clearEmailHtml}
      />
    </>
  );
}

function CampaignDetailsDrawer({ campaign, onClose, onChanged }) {
  const { t } = useTranslation();
  const [recipients, setRecipients] = useState([]);
  const [loadingRecipients, setLoadingRecipients] = useState(true);
  const [testEmail, setTestEmail] = useState("");
  const [testTelegram, setTestTelegram] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [settings, setSettings] = useState({
    auto_delete_enabled: campaign?.auto_delete_enabled !== false,
    delete_after_days: getDeleteAfterDays(campaign),
    ends_at: normalizeDateTimeInput(campaign?.ends_at),
    birthday_coupon_valid_days: Number(
      campaign?.birthday_coupon_valid_days || 7
    ),
  });

  useEffect(() => {
    setSettings({
      auto_delete_enabled: campaign?.auto_delete_enabled !== false,
      delete_after_days: getDeleteAfterDays(campaign),
      ends_at: normalizeDateTimeInput(campaign?.ends_at),
      birthday_coupon_valid_days: Number(
        campaign?.birthday_coupon_valid_days || 7
      ),
    });
  }, [
    campaign.id,
    campaign.ends_at,
    campaign.auto_delete_enabled,
    campaign.delete_after_days,
    campaign.birthday_coupon_valid_days,
  ]);

  useEffect(() => {
    let mounted = true;
    setLoadingRecipients(true);
    marketingApi
      .listRecipients(campaign.id)
      .then((items) => mounted && setRecipients(items || []))
      .catch(() => mounted && setRecipients([]))
      .finally(() => mounted && setLoadingRecipients(false));
    return () => {
      mounted = false;
    };
  }, [campaign.id]);

  const start = async () => {
    setError("");
    setMessage("");
    try {
      await marketingApi.startCampaign(campaign.id, true);
      setMessage(t("marketing_queued_success"));
      await onChanged();
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_campaign_start_failed")));
    }
  };

  const cancel = async () => {
    setError("");
    setMessage("");
    try {
      await marketingApi.cancelCampaign(campaign.id);
      setMessage(t("marketing_cancelled_success"));
      await onChanged();
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_campaign_cancel_failed")));
    }
  };

  const sendTest = async () => {
    setError("");
    setMessage("");
    try {
      await marketingApi.testSend(campaign.id, {
        email: testEmail || null,
        telegram_chat_id: testTelegram || null,
      });
      setMessage(t("marketing_test_sent_success"));
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_test_send_failed")));
    }
  };

  const saveAutoDeleteSettings = async () => {
    setError("");
    setMessage("");

    try {
      setSaving(true);
      await patchCampaign(campaign.id, {
        auto_delete_enabled: Boolean(settings.auto_delete_enabled),
        delete_after_days: Number(settings.delete_after_days || 30),
      });
      setMessage(t("marketing_auto_delete_saved"));
      await onChanged();
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_auto_delete_save_failed")));
    } finally {
      setSaving(false);
    }
  };

  const saveBirthdayValidity = async () => {
    setError("");
    setMessage("");

    const validDays = Number(settings.birthday_coupon_valid_days);
    if (
      !Number.isInteger(validDays) ||
      validDays < 1 ||
      validDays > 365
    ) {
      setError(t("marketing_birthday_validity_validation"));
      return;
    }

    try {
      setSaving(true);
      await patchCampaign(campaign.id, {
        birthday_coupon_valid_days: validDays,
      });
      setMessage(t("marketing_birthday_validity_saved"));
      await onChanged();
    } catch (e) {
      setError(
        getApiErrorText(
          e,
          t("marketing_birthday_validity_save_failed")
        )
      );
    } finally {
      setSaving(false);
    }
  };

  const extendCampaign = async () => {
    setError("");
    setMessage("");

    if (!settings.ends_at) {
      setError(t("marketing_select_new_end_date"));
      return;
    }

    if (compareDateTimeLocal(settings.ends_at, nowForDateTimeLocal()) < 0) {
      setError(t("marketing_new_end_date_future"));
      return;
    }

    try {
      setSaving(true);
      await patchCampaign(campaign.id, {
        ends_at: dateToApi(settings.ends_at),
        status: campaign.status === "draft" ? "draft" : "active",
        auto_delete_enabled: Boolean(settings.auto_delete_enabled),
        delete_after_days: Number(settings.delete_after_days || 30),
      });
      setMessage(t("marketing_extended_success"));
      await onChanged();
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_campaign_extend_failed")));
    } finally {
      setSaving(false);
    }
  };

  const deleteCampaign = async () => {
    setError("");
    setMessage("");

    const confirmed = window.confirm(
      t("marketing_force_delete_confirm")
    );
    if (!confirmed) return;

    const typed = window.prompt(t("marketing_delete_word_prompt"));
    if (typed !== t("marketing_delete_confirmation_word")) return;

    try {
      setSaving(true);
      await api.delete(`/marketing/campaigns/${campaign.id}/hard-delete`);
      await onChanged();
      onClose();
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_campaign_delete_failed")));
    } finally {
      setSaving(false);
    }
  };

  const sent =
    getCampaignStat(campaign, "email", "sent") +
    getCampaignStat(campaign, "telegram", "sent");
  const pendingDelete = isPendingDeleteCampaign(campaign);
  const daysUntilDelete = getDaysUntilDelete(campaign);

  return (
    <Drawer
      title={campaign.title || t("marketing_campaign")}
      subtitle={t("marketing_campaign_number", { id: campaign.id })}
      wide
      onClose={onClose}
      footer={
        <>
          <button className="vcrm-btn secondary" type="button" onClick={onClose} disabled={saving}>
            {t("close")}
          </button>
          <button className="vcrm-btn danger ghostDanger" type="button" onClick={deleteCampaign} disabled={saving}>
            {saving ? t("deleting") : t("marketing_delete_permanently")}
          </button>
          <button className="vcrm-btn danger" type="button" onClick={cancel} disabled={saving}>
            {t("marketing_cancel_action")}
          </button>
          <button className="vcrm-btn primary" type="button" onClick={start} disabled={saving || pendingDelete}>
            {t("marketing_launch_continue")}
          </button>
        </>
      }
    >
      {message && <div className="vcrm-alert success">{message}</div>}
      {error && <div className="vcrm-alert error">{error}</div>}

      <div className="vcrm-detailsHero">
        <div className="vcrm-detailsIcon">🎁</div>
        <div>
          <StatusPill status={pendingDelete ? "pending_delete" : campaign.status} />
          <h3>{campaign.title}</h3>
          <p>{campaign.description || t("marketing_description_empty")}</p>
          {pendingDelete && (
            <div className="vcrm-deleteNotice wide">
              {t("marketing_not_shown_contacts")} {daysUntilDelete !== null ? t("marketing_auto_delete_in_days", { count: daysUntilDelete }) : t("marketing_auto_delete_disabled")}
            </div>
          )}
        </div>
      </div>

      <div className="vcrm-metricGrid">
        <Metric label={t("crm_activities_channel")} value={CHANNEL_LABELS[campaign.delivery_channel] ? t(CHANNEL_LABELS[campaign.delivery_channel]) : campaign.delivery_channel || "—"} />
        <Metric label={t("contact_type")} value={TYPE_LABELS[campaign.campaign_type] ? t(TYPE_LABELS[campaign.campaign_type]) : campaign.campaign_type || "—"} />
        <Metric label={t("marketing_launch")} value={TRIGGER_LABELS[campaign.trigger_type] ? t(TRIGGER_LABELS[campaign.trigger_type]) : campaign.trigger_type || "—"} />
        <Metric label={t("chat_sent")} value={sent} />
        <Metric label={t("marketing_recipients")} value={campaign.recipients_count || 0} />
        <Metric label={t("marketing_coupons_count")} value={campaign.coupons_count || 0} />
        <Metric
          label={t("marketing_start")}
          value={
            campaign.trigger_type === "birthday"
              ? t("marketing_birthday_contact_day")
              : formatDate(campaign.starts_at)
          }
        />
        <Metric
          label={t("marketing_end")}
          value={
            campaign.trigger_type === "birthday"
              ? t("marketing_birthday_offer_validity_days", {
                  days: Number(
                    campaign.birthday_coupon_valid_days || 7
                  ),
                })
              : formatDate(campaign.ends_at)
          }
        />
        <Metric label={t("marketing_auto_delete")} value={campaign.auto_delete_enabled === false ? t("disabled") : formatDate(getDeleteAfterDate(campaign))} />
      </div>

      {campaign.trigger_type === "birthday" ? (
        <section className="vcrm-formSection">
          <div className="vcrm-sectionTitle">
            <span>⚙</span>
            <div>
              <h3>{t("marketing_birthday_period_settings_title")}</h3>
              <p>{t("marketing_birthday_period_settings_hint")}</p>
            </div>
          </div>

          <div className="vcrm-formGrid">
            <Field label={t("marketing_end_date")}>
              <select
                className="vcrm-input"
                value={
                  [7, 14, 21, 30].includes(
                    Number(settings.birthday_coupon_valid_days)
                  )
                    ? String(settings.birthday_coupon_valid_days)
                    : "custom"
                }
                onChange={(event) => {
                  const value = event.target.value;
                  setSettings((prev) => ({
                    ...prev,
                    birthday_coupon_valid_days:
                      value === "custom" ? 10 : Number(value),
                  }));
                }}
              >
                <option value="7">{t("seven_days")}</option>
                <option value="14">{t("marketing_days_14")}</option>
                <option value="21">{t("marketing_days_21")}</option>
                <option value="30">{t("marketing_days_30")}</option>
                <option value="custom">
                  {t("marketing_custom_value")}
                </option>
              </select>
              <small className="vcrm-fieldHint">
                {t("marketing_birthday_offer_validity_hint")}
              </small>
            </Field>

            {![7, 14, 21, 30].includes(
              Number(settings.birthday_coupon_valid_days)
            ) && (
              <Field label={t("marketing_custom_days")}>
                <input
                  className="vcrm-input"
                  type="number"
                  min="1"
                  max="365"
                  step="1"
                  value={settings.birthday_coupon_valid_days}
                  onChange={(event) =>
                    setSettings((prev) => ({
                      ...prev,
                      birthday_coupon_valid_days: event.target.value,
                    }))
                  }
                />
              </Field>
            )}

            <div className="vcrm-rowActions full">
              <button
                className="vcrm-btn primary"
                type="button"
                onClick={saveBirthdayValidity}
                disabled={saving}
              >
                {t("marketing_save_settings")}
              </button>
            </div>
          </div>
        </section>
      ) : (
        <section className="vcrm-formSection">
          <div className="vcrm-sectionTitle">
            <span>⚙</span>
            <div>
              <h3>{t("marketing_extension_auto_delete")}</h3>
              <p>{t("marketing_extension_hint")}</p>
            </div>
          </div>

          <div className="vcrm-formGrid">
            <Field label={t("marketing_new_end_date")}>
              <input
                className="vcrm-input"
                type="datetime-local"
                min={nowForDateTimeLocal()}
                value={settings.ends_at}
                onChange={(event) => setSettings((prev) => ({ ...prev, ends_at: event.target.value }))}
              />
            </Field>

            <Field label={t("marketing_delete_after_days")}>
              <input
                className="vcrm-input"
                type="number"
                min="1"
                max="365"
                disabled={!settings.auto_delete_enabled}
                value={settings.delete_after_days}
                onChange={(event) => setSettings((prev) => ({ ...prev, delete_after_days: event.target.value }))}
              />
            </Field>

            <label className="vcrm-check full">
              <input
                type="checkbox"
                checked={settings.auto_delete_enabled}
                onChange={(event) => setSettings((prev) => ({ ...prev, auto_delete_enabled: event.target.checked }))}
              />
              <span>{t("marketing_enable_auto_delete_after_end")}</span>
            </label>

            <div className="vcrm-rowActions full">
              <button className="vcrm-btn secondary" type="button" onClick={saveAutoDeleteSettings} disabled={saving}>
                {t("marketing_save_settings")}
              </button>
              <button className="vcrm-btn primary" type="button" onClick={extendCampaign} disabled={saving}>
                {t("marketing_extend_restore")}
              </button>
            </div>
          </div>
        </section>
      )}

      <div className="vcrm-detailsGrid">
        <section className="vcrm-formSection noMargin">
          <div className="vcrm-sectionTitle">
            <span>01</span>
            <div>
              <h3>{t("recipients")}</h3>
              <p>{loadingRecipients ? t("loading") : t("marketing_recipients_count", { count: recipients.length })}</p>
            </div>
          </div>

          <div className="vcrm-recipientList">
            {recipients.slice(0, 30).map((item) => (
              <div className="vcrm-recipientItem" key={item.id}>
                <strong>{item.contact_name || `Contact #${item.contact_id}`}</strong>
                <span>
                  {t("marketing_email_label")}{" "}
                  {getDeliveryStatusLabel(item.email_status, "email", t)}{" "}
                  {t("marketing_telegram_label")}{" "}
                  {getDeliveryStatusLabel(item.telegram_status, "telegram", t)}
                </span>
                {item.error_message && (
                  <small className="vcrm-deliveryError">
                    {t("marketing_delivery_error")}{" "}
                    {getDeliveryErrorText(item.error_message, t)}
                  </small>
                )}
              </div>
            ))}

            {!loadingRecipients && recipients.length === 0 && (
              <div className="vcrm-miniEmpty">{t("marketing_no_recipients")}</div>
            )}
          </div>
        </section>

        <aside className="vcrm-testCard">
          <h3>{t("marketing_test_delivery")}</h3>
          <input
            className="vcrm-input"
            value={testEmail}
            onChange={(event) => setTestEmail(event.target.value)}
            placeholder={t("marketing_test_email_placeholder")}
          />
          <input
            className="vcrm-input"
            value={testTelegram}
            onChange={(event) => setTestTelegram(event.target.value)}
            placeholder="Telegram chat_id"
          />
          <button className="vcrm-btn secondary" type="button" onClick={sendTest} disabled={saving}>
            {t("marketing_send_test")}
          </button>
        </aside>
      </div>

      <section className="vcrm-timeline">
        <h3>{t("marketing_history")}</h3>
        <div>
          <span className="done" />
          <p>{t("marketing_campaign_created")}</p>
        </div>
        <div>
          <span className={["scheduled", "active", "sending", "completed"].includes(campaign.status) ? "done" : ""} />
          <p>{t("marketing_added_to_queue")}</p>
        </div>
        <div>
          <span className={getCampaignStat(campaign, "email", "sent") ? "done" : ""} />
          <p>{t("marketing_email_deliveries")}</p>
        </div>
        <div>
          <span className={getCampaignStat(campaign, "telegram", "sent") ? "done" : ""} />
          <p>{t("marketing_telegram_deliveries")}</p>
        </div>
        <div>
          <span className={pendingDelete ? "done" : ""} />
          <p>{t("marketing_pending_deletion")}</p>
        </div>
      </section>
    </Drawer>
  );
}

function CouponDrawer({ couponForm, setCouponForm, onClose, onCreate }) {
  const { t } = useTranslation();
  return (
    <Drawer
      title={t("marketing_new_coupon")}
      subtitle={t("marketing_manual_coupon_subtitle")}
      onClose={onClose}
      footer={
        <>
          <button className="vcrm-btn secondary" type="button" onClick={onClose}>
            {t("cancel")}
          </button>
          <button className="vcrm-btn primary" type="button" onClick={onCreate}>
            {t("marketing_create_coupon")}
          </button>
        </>
      }
    >
      <div className="vcrm-formGrid one">
        <Field label={t("account_code")}>
          <input
            className="vcrm-input"
            value={couponForm.code}
            onChange={(event) => setCouponForm((prev) => ({ ...prev, code: event.target.value.toUpperCase() }))}
            placeholder={t("marketing_auto_generate_placeholder")}
          />
        </Field>

        <Field label={t("contact_type")}>
          <select
            className="vcrm-input"
            value={couponForm.coupon_type}
            onChange={(event) => setCouponForm((prev) => ({ ...prev, coupon_type: event.target.value }))}
          >
            <option value="personal">{t("account_email_mode_personal")}</option>
            <option value="public">{t("marketing_coupon_public")}</option>
            <option value="birthday">{t("preset_contact_field_birthday")}</option>
            <option value="referral">{t("source_preset_referral")}</option>
            <option value="gift">{t("marketing_gift")}</option>
          </select>
        </Field>

        <Field label={t("marketing_contact_id")}>
          <input
            className="vcrm-input"
            value={couponForm.contact_id}
            onChange={(event) => setCouponForm((prev) => ({ ...prev, contact_id: event.target.value }))}
          />
        </Field>

        <Field label={t("marketing_campaign_id")}>
          <input
            className="vcrm-input"
            value={couponForm.campaign_id}
            onChange={(event) => setCouponForm((prev) => ({ ...prev, campaign_id: event.target.value }))}
          />
        </Field>

        <Field label={t("marketing_discount_type")}>
          <select
            className="vcrm-input"
            value={couponForm.discount_type}
            onChange={(event) => setCouponForm((prev) => ({ ...prev, discount_type: event.target.value }))}
          >
            <option value="percent">{t("percentage")}</option>
            <option value="fixed">{t("marketing_fixed_amount")}</option>
            <option value="gift">{t("marketing_gift")}</option>
          </select>
        </Field>

        <Field label={t("dashboard_value")}>
          <input
            className="vcrm-input"
            type="number"
            value={couponForm.discount_value}
            onChange={(event) => setCouponForm((prev) => ({ ...prev, discount_value: event.target.value }))}
          />
        </Field>
      </div>
    </Drawer>
  );
}

export default function MarketingPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState("overview");
  const [campaigns, setCampaigns] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [emailJobs, setEmailJobs] = useState([]);
  const [telegramJobs, setTelegramJobs] = useState([]);

  const [statusFilter, setStatusFilter] = useState("");
  const [archiveFilter, setArchiveFilter] = useState("all");
  const [couponFilter, setCouponFilter] = useState("");

  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [showCouponCreate, setShowCouponCreate] = useState(false);
  const [initialCampaignForm, setInitialCampaignForm] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [couponForm, setCouponForm] = useState(emptyCouponForm);
  const [couponCheck, setCouponCheck] = useState({ code: "", contact_id: "" });
  const [couponResult, setCouponResult] = useState(null);

  const loadCampaigns = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await marketingApi.listCampaigns({
        status: statusFilter || undefined,
        limit: 100,
      });
      setCampaigns(data.items || []);
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_campaigns_load_failed")));
    } finally {
      setLoading(false);
    }
  };

  const loadCoupons = async () => {
    try {
      const data = await marketingApi.listCoupons({
        status: couponFilter || undefined,
        limit: 100,
      });
      setCoupons(data.items || []);
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_coupons_load_failed")));
    }
  };

  const loadJobs = async () => {
    try {
      const [emails, telegrams] = await Promise.all([
        marketingApi.listJobs({ channel: "email" }),
        marketingApi.listJobs({ channel: "telegram" }),
      ]);
      setEmailJobs(emails || []);
      setTelegramJobs(telegrams || []);
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_queue_load_failed")));
    }
  };


  const refreshAll = async () => {
    await Promise.all([loadCampaigns(), loadCoupons(), loadJobs()]);
  };

  useEffect(() => {
    loadCampaigns();
  }, [statusFilter]);

  useEffect(() => {
    loadCoupons();
  }, [couponFilter]);

  useEffect(() => {
    loadJobs();
  }, []);

  const stats = useMemo(() => {
    const usedCoupons = coupons.filter((item) => item.status === "used").length;
    const sent = campaigns.reduce(
      (sum, campaign) =>
        sum +
        getCampaignStat(campaign, "email", "sent") +
        getCampaignStat(campaign, "telegram", "sent"),
      0
    );
    const active = campaigns.filter((item) => canShowInContacts(item)).length;

    return {
      campaigns: campaigns.length,
      active,
      coupons: coupons.length,
      usedCoupons,
      sent,
      conversion: coupons.length ? Math.round((usedCoupons / coupons.length) * 100) : 0,
    };
  }, [campaigns, coupons]);

  const jobs = useMemo(
    () => [
      ...emailJobs.map((item) => ({ ...item, channel: "email" })),
      ...telegramJobs.map((item) => ({ ...item, channel: "telegram" })),
    ],
    [emailJobs, telegramJobs]
  );


  const activeCampaigns = useMemo(
    () => campaigns.filter((campaign) => canShowInContacts(campaign)),
    [campaigns]
  );

  const globalBirthdayExists = useMemo(
    () =>
      campaigns.some(
        (campaign) =>
          campaign.campaign_type === "global" &&
          campaign.trigger_type === "birthday" &&
          GLOBAL_BIRTHDAY_ACTIVE_STATUSES.includes(campaign.status)
      ),
    [campaigns]
  );

  const archiveCampaigns = useMemo(
    () => campaigns.filter((campaign) => isPendingDeleteCampaign(campaign)),
    [campaigns]
  );

  const expiredCampaigns = useMemo(
    () => archiveCampaigns.filter((campaign) => isPastDate(campaign?.ends_at) && !["cancelled", "completed"].includes(campaign?.status)),
    [archiveCampaigns]
  );

  const cancelledCampaigns = useMemo(
    () => archiveCampaigns.filter((campaign) => campaign?.status === "cancelled"),
    [archiveCampaigns]
  );

  const pendingDeleteCampaigns = useMemo(
    () => archiveCampaigns.filter((campaign) => campaign?.auto_delete_enabled !== false),
    [archiveCampaigns]
  );

  const visibleArchiveCampaigns = useMemo(() => {
    if (archiveFilter === "expired") return expiredCampaigns;
    if (archiveFilter === "pending_delete") return pendingDeleteCampaigns;
    if (archiveFilter === "cancelled") return cancelledCampaigns;
    return archiveCampaigns;
  }, [archiveFilter, archiveCampaigns, expiredCampaigns, pendingDeleteCampaigns, cancelledCampaigns]);

  const openTemplate = (template) => {
    setInitialCampaignForm({
      ...emptyCampaignForm,
      title: t(template.title),
      description: t(template.description),
      campaign_type: template.campaign_type,
      trigger_type: template.trigger_type,
      delivery_channel: template.delivery_channel,
      telegram_text: template.telegram_text ? t(template.telegram_text) : "",
      email_subject: template.email_subject ? t(template.email_subject) : "",
      email_html:
        template.key === "birthday"
          ? buildProfessionalBirthdayEmailTemplate(t)
          : template.email_html
            ? t(template.email_html)
            : "",
      contact_ids: [],
    });
    setShowCreate(true);
  };

  const openBlankCampaign = () => {
    setInitialCampaignForm(emptyCampaignForm);
    setShowCreate(true);
  };

  const createCoupon = async () => {
    setError("");
    setSuccess("");

    try {
      await marketingApi.createCoupon({
        code: couponForm.code || null,
        contact_id: couponForm.contact_id ? Number(couponForm.contact_id) : null,
        campaign_id: couponForm.campaign_id ? Number(couponForm.campaign_id) : null,
        coupon_type: couponForm.coupon_type,
        discount_type: couponForm.discount_type,
        discount_value:
          couponForm.discount_value !== "" ? Number(couponForm.discount_value) : null,
        starts_at: dateToApi(couponForm.starts_at),
        ends_at: dateToApi(couponForm.ends_at),
      });

      setCouponForm(emptyCouponForm);
      setShowCouponCreate(false);
      setSuccess(t("marketing_coupon_created"));
      await loadCoupons();
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_coupon_create_failed")));
    }
  };

  const checkCoupon = async (apply = false) => {
    setCouponResult(null);
    setError("");

    try {
      const payload = {
        code: couponCheck.code,
        contact_id: couponCheck.contact_id ? Number(couponCheck.contact_id) : null,
      };

      const result = apply
        ? await marketingApi.applyCoupon(payload)
        : await marketingApi.checkCoupon(payload);

      setCouponResult(result);
      if (apply && result.ok) await loadCoupons();
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_coupon_check_failed")));
    }
  };

  const processJobs = async () => {
    setError("");
    setSuccess("");

    try {
      const result = await marketingApi.processJobs();
      setSuccess(t("marketing_queue_processed", {
        email: result.email_sent || 0,
        telegram: result.telegram_sent || 0,
      }));
      await refreshAll();
    } catch (e) {
      setError(getApiErrorText(e, t("marketing_queue_process_failed")));
    }
  };

  return (
    <div className="vcrm-page">
      <header data-academy="marketing-header" className="vcrm-pageHeader">
        <div>
          <span className="vcrm-eyebrow">{t("marketing_brand")}</span>
          <h1>{t("marketing")}</h1>
          <p>{t("marketing_module_description")}</p>
        </div>

        <div data-academy="marketing-create" className="vcrm-headerActions">
          <button className="vcrm-btn secondary" type="button" onClick={refreshAll} disabled={loading}>
            {loading ? t("updating") : t("refresh")}
          </button>
          <button className="vcrm-btn primary" type="button" onClick={openBlankCampaign}>
            {t("marketing_add_campaign")}
          </button>
        </div>
      </header>

      {error && <div className="vcrm-alert error">{error}</div>}
      {success && <div className="vcrm-alert success">{success}</div>}

      <section data-academy="marketing-metrics" className="vcrm-metricGrid top">
        <Metric label={t("marketing_campaigns")} value={stats.campaigns} note={t("marketing_active_archive_counts", { active: stats.active, archive: archiveCampaigns.length })} />
        <Metric label={t("chat_sent")} value={stats.sent} note={t("marketing_channel_both")} />
        <Metric label={t("academy_page_title_081")} value={stats.coupons} note={t("marketing_used_count", { count: stats.usedCoupons })} />
        <Metric label={t("dashboard_win_rate")} value={`${stats.conversion}%`} note={t("marketing_by_coupons")} />
      </section>

      <nav data-academy="marketing-tabs" className="vcrm-tabs">
        <button data-academy-tab="marketing-overview" className={tab === "overview" ? "active" : ""} onClick={() => setTab("overview")}>
          {t("dashboard")}
        </button>
        <button data-academy-tab="marketing-campaigns" className={tab === "campaigns" ? "active" : ""} onClick={() => setTab("campaigns")}>
          {t("marketing_active_tab")}{activeCampaigns.length})
        </button>
        <button data-academy-tab="marketing-archive" className={tab === "archive" ? "active" : ""} onClick={() => setTab("archive")}>
          {t("marketing_archive_tab")}{archiveCampaigns.length})
        </button>
        <button data-academy-tab="marketing-coupons" className={tab === "coupons" ? "active" : ""} onClick={() => setTab("coupons")}>
          {t("marketing_coupons_tab")}{coupons.length})
        </button>
        <button data-academy-tab="marketing-jobs" className={tab === "jobs" ? "active" : ""} onClick={() => setTab("jobs")}>
          {t("marketing_queue_tab")}{jobs.length})
        </button>
        <button data-academy-tab="marketing-stats" className={tab === "stats" ? "active" : ""} onClick={() => setTab("stats")}>
          {t("dashboard_rate_limiting_stats")}
        </button>
      </nav>

      {tab === "overview" && (
        <div data-academy="marketing-overview" className="vcrm-dashboardGrid">
          <QuickActions onTemplate={openTemplate} />

          <section className="vcrm-panel">
            <div className="vcrm-panelHead">
              <div>
                <h2>{t("marketing_recent_campaigns")}</h2>
                <p>{t("marketing_recent_campaigns_hint")}</p>
              </div>
              <button className="vcrm-linkBtn" type="button" onClick={() => setTab("campaigns")}>
                {t("marketing_active_campaigns_link")}
              </button>
            </div>

            <div className="vcrm-campaignGrid compact">
              {activeCampaigns.slice(0, 6).map((campaign) => (
                <CampaignCard
                  key={campaign.id}
                  campaign={campaign}
                  onOpen={() => setSelectedCampaign(campaign)}
                />
              ))}
              {!loading && activeCampaigns.length === 0 && (
                <EmptyState
                  title={t("marketing_no_active_campaigns")}
                  text={t("marketing_create_first_campaign")}
                  action={
                    <button className="vcrm-btn primary" type="button" onClick={openBlankCampaign}>
                      {t("marketing_add_campaign")}
                    </button>
                  }
                />
              )}
            </div>
          </section>
        </div>
      )}

      {tab === "campaigns" && (
        <section data-academy="marketing-campaigns" className="vcrm-panel">
          <div className="vcrm-panelHead">
            <div>
              <h2>{t("marketing_active_campaigns")}</h2>
              <p>{t("marketing_active_campaigns_description")}</p>
            </div>

            <div className="vcrm-rowActions">
              <select
                className="vcrm-input compact"
                value={statusFilter}
                onChange={(event) => setStatusFilter(event.target.value)}
              >
                <option value="">{t("all_statuses")}</option>
                {CAMPAIGN_STATUSES.map((status) => (
                  <option key={status} value={status}>
                    {t(`marketing_status_${status}`, { defaultValue: status })}
                  </option>
                ))}
              </select>
              <button className="vcrm-btn primary" type="button" onClick={openBlankCampaign}>
                {t("marketing_add_campaign")}
              </button>
            </div>
          </div>

          <div className="vcrm-campaignGrid">
            {activeCampaigns.map((campaign) => (
              <CampaignCard
                key={campaign.id}
                campaign={campaign}
                onOpen={() => setSelectedCampaign(campaign)}
              />
            ))}
            {!loading && activeCampaigns.length === 0 && (
              <EmptyState
                title={t("marketing_no_active_campaigns")}
                text={t("marketing_create_or_extend_campaign")}
                action={
                  <button className="vcrm-btn primary" type="button" onClick={openBlankCampaign}>
                    {t("marketing_add_campaign")}
                  </button>
                }
              />
            )}
          </div>
        </section>
      )}

      {tab === "archive" && (
        <section data-academy="marketing-archive" className="vcrm-panel vcrm-archivePanel">
          <div className="vcrm-archiveHero">
            <div>
              <span className="vcrm-eyebrow">{t("marketing_archive_control")}</span>
              <h2>{t("marketing_campaign_archive")}</h2>
              <p>{t("marketing_archive_description")}</p>
            </div>

            <div className="vcrm-archiveHeroStats">
              <div>
                <strong>{archiveCampaigns.length}</strong>
                <span>{t("marketing_in_archive")}</span>
              </div>
              <div>
                <strong>{pendingDeleteCampaigns.length}</strong>
                <span>{t("marketing_auto_delete_count")}</span>
              </div>
              <div>
                <strong>{expiredCampaigns.length}</strong>
                <span>{t("marketing_expired")}</span>
              </div>
            </div>
          </div>

          <div className="vcrm-archiveToolbar">
            <div className="vcrm-segmented">
              <button type="button" className={archiveFilter === "all" ? "active" : ""} onClick={() => setArchiveFilter("all")}>
                {t("marketing_all_tab")}{archiveCampaigns.length})
              </button>
              <button type="button" className={archiveFilter === "expired" ? "active" : ""} onClick={() => setArchiveFilter("expired")}>
                {t("marketing_expired_tab")}{expiredCampaigns.length})
              </button>
              <button type="button" className={archiveFilter === "pending_delete" ? "active" : ""} onClick={() => setArchiveFilter("pending_delete")}>
                {t("marketing_pending_delete_tab")}{pendingDeleteCampaigns.length})
              </button>
              <button type="button" className={archiveFilter === "cancelled" ? "active" : ""} onClick={() => setArchiveFilter("cancelled")}>
                {t("marketing_cancelled_tab")}{cancelledCampaigns.length})
              </button>
            </div>
          </div>

          <div className="vcrm-archiveList">
            {visibleArchiveCampaigns.map((campaign) => (
              <ArchiveCampaignCard
                key={campaign.id}
                campaign={campaign}
                onOpen={() => setSelectedCampaign(campaign)}
              />
            ))}
            {!loading && visibleArchiveCampaigns.length === 0 && (
              <EmptyState
                title={t("archive_empty")}
                text={t("marketing_archive_empty_hint")}
              />
            )}
          </div>
        </section>
      )}

      {tab === "coupons" && (
        <section data-academy="marketing-coupons" className="vcrm-panel">
          <div className="vcrm-panelHead">
            <div>
              <h2>{t("academy_page_title_081")}</h2>
              <p>{t("marketing_coupon_section_hint")}</p>
            </div>

            <div className="vcrm-rowActions">
              <select
                className="vcrm-input compact"
                value={couponFilter}
                onChange={(event) => setCouponFilter(event.target.value)}
              >
                <option value="">{t("all")}</option>
                {COUPON_STATUSES.map((status) => (
                  <option key={status} value={status}>
                    {t(`marketing_status_${status}`, { defaultValue: status })}
                  </option>
                ))}
              </select>
              <button className="vcrm-btn primary" type="button" onClick={() => setShowCouponCreate(true)}>
                {t("marketing_add_coupon")}
              </button>
            </div>
          </div>

          <div className="vcrm-couponCheck">
            <input
              className="vcrm-input"
              value={couponCheck.code}
              onChange={(event) =>
                setCouponCheck((prev) => ({ ...prev, code: event.target.value.toUpperCase() }))
              }
              placeholder={t("deal_coupon_enter_code")}
            />
            <input
              className="vcrm-input"
              value={couponCheck.contact_id}
              onChange={(event) =>
                setCouponCheck((prev) => ({ ...prev, contact_id: event.target.value }))
              }
              placeholder={t("marketing_contact_id")}
            />
            <button className="vcrm-btn secondary" type="button" onClick={() => checkCoupon(false)}>
              {t("marketing_validate")}
            </button>
            <button className="vcrm-btn success" type="button" onClick={() => checkCoupon(true)}>
              {t("apply")}
            </button>
          </div>

          {couponResult && (
            <div className={`vcrm-alert ${couponResult.ok ? "success" : "error"}`}>
              {couponResult.ok
                ? t("marketing_coupon_valid", { code: couponResult.coupon?.code })
                : t("marketing_coupon_invalid", { reason: couponResult.reason })}
            </div>
          )}

          <div className="vcrm-couponGrid">
            {coupons.map((coupon) => (
              <article className="vcrm-couponCard" key={coupon.id}>
                <div>
                  <code>{coupon.code}</code>
                  <StatusPill status={coupon.status} />
                </div>
                <strong>
                  {coupon.discount_type || "—"} {coupon.discount_value || ""}
                </strong>
                <span>{coupon.contact_name || coupon.contact_id || t("marketing_public_coupon")}</span>
                <small>{t("marketing_valid_until")} {formatDate(coupon.ends_at)}</small>
              </article>
            ))}
            {coupons.length === 0 && <EmptyState title={t("marketing_no_coupons")} />}
          </div>
        </section>
      )}

      {tab === "jobs" && (
        <section data-academy="marketing-jobs" className="vcrm-panel">
          <div className="vcrm-panelHead">
            <div>
              <h2>{t("academy_page_title_082")}</h2>
              <p>{t("marketing_queue_description")}</p>
            </div>
            <button className="vcrm-btn primary" type="button" onClick={processJobs}>
              {t("marketing_process_now")}
            </button>
          </div>

          <div className="vcrm-jobGrid">
            {jobs.map((job) => (
              <article className="vcrm-jobCard" key={`${job.channel}-${job.id}`}>
                <div>
                  <strong>{t(CHANNEL_LABELS[job.channel])} #{job.id}</strong>
                  <StatusPill
                    status={job.status}
                    label={
                      job.channel === "email" && job.status === "sent"
                        ? t("marketing_status_smtp_accepted")
                        : undefined
                    }
                  />
                </div>
                <p>{t("marketing_campaign_label")} {job.campaign_id} {t("marketing_recipient_label")} {job.recipient_id}</p>
                <small>{formatDate(job.scheduled_at)} {t("marketing_attempts_label")} {job.attempts || 0}</small>
                {job.error_message && (
                  <em>{getDeliveryErrorText(job.error_message, t)}</em>
                )}
              </article>
            ))}
            {jobs.length === 0 && <EmptyState title={t("marketing_empty_queue")} />}
          </div>
        </section>
      )}

      {tab === "stats" && (
        <section data-academy="marketing-stats" className="vcrm-panel">
          <div className="vcrm-panelHead">
            <div>
              <h2>{t("dashboard_rate_limiting_stats")}</h2>
              <p>{t("marketing_statistics_description")}</p>
            </div>
          </div>

          <div className="vcrm-metricGrid">
            <Metric label={t("marketing_delivered_total")} value={stats.sent} />
            <Metric label={t("marketing_coupons_used")} value={stats.usedCoupons} />
            <Metric label={t("marketing_coupons_total")} value={stats.coupons} />
            <Metric label={t("dashboard_win_rate")} value={`${stats.conversion}%`} />
          </div>

          <div className="vcrm-statList">
            {campaigns.map((campaign) => (
              <article className="vcrm-statRow" key={campaign.id}>
                <div>
                  <strong>{campaign.title}</strong>
                  <span>
                    {CHANNEL_LABELS[campaign.delivery_channel]
                      ? t(CHANNEL_LABELS[campaign.delivery_channel])
                      : campaign.delivery_channel}
                  </span>
                </div>
                <Metric
                  label={t("email")}
                  value={`${getCampaignStat(campaign, "email", "sent")}/${getCampaignStat(campaign, "email", "failed")}`}
                />
                <Metric
                  label={t("source_preset_telegram")}
                  value={`${getCampaignStat(campaign, "telegram", "sent")}/${getCampaignStat(campaign, "telegram", "failed")}`}
                />
                <Metric label={t("academy_page_title_081")} value={campaign.coupons_count || 0} />
                <Metric label={t("marketing_used")} value={getCampaignCouponsUsed(campaign)} />
              </article>
            ))}
          </div>
        </section>
      )}

      {showCreate && (
        <CampaignDrawer
          initialForm={initialCampaignForm}
          globalBirthdayExists={globalBirthdayExists}
          onClose={() => setShowCreate(false)}
          onCreated={async () => {
            setSuccess(t("marketing_campaign_created"));
            await refreshAll();
          }}
        />
      )}

      {selectedCampaign && (
        <CampaignDetailsDrawer
          campaign={selectedCampaign}
          onClose={() => setSelectedCampaign(null)}
          onChanged={refreshAll}
        />
      )}

      {showCouponCreate && (
        <CouponDrawer
          couponForm={couponForm}
          setCouponForm={setCouponForm}
          onClose={() => setShowCouponCreate(false)}
          onCreate={createCoupon}
        />
      )}
    </div>
  );
}
